import invariant from 'tiny-invariant';

// src/enums/chain-aptos.ts
var AptosChain = /* @__PURE__ */ ((AptosChain2) => {
  AptosChain2["APTOS"] = "aptos";
  AptosChain2["MOVEMENT"] = "movement";
  return AptosChain2;
})(AptosChain || {});

// src/enums/chain-evm.ts
var EvmChain = /* @__PURE__ */ ((EvmChain2) => {
  EvmChain2["ETHEREUM"] = "ethereum";
  EvmChain2["BSC"] = "bsc";
  EvmChain2["AVALANCHE"] = "avalanche";
  EvmChain2["POLYGON"] = "polygon";
  EvmChain2["ZKPOLYGON"] = "zkpolygon";
  EvmChain2["ARBITRUM"] = "arbitrum";
  EvmChain2["OPTIMISM"] = "optimism";
  EvmChain2["FANTOM"] = "fantom";
  EvmChain2["SWIMMER"] = "swimmer";
  EvmChain2["DFK"] = "dfk";
  EvmChain2["HARMONY"] = "harmony";
  EvmChain2["ARCANA"] = "arcana";
  EvmChain2["DEXALOT"] = "dexalot";
  EvmChain2["CASTLECRUSH"] = "castlecrush";
  EvmChain2["GNOSIS"] = "gnosis";
  EvmChain2["CELO"] = "celo";
  EvmChain2["MOONBEAM"] = "moonbeam";
  EvmChain2["BOBA"] = "boba";
  EvmChain2["PORTAL"] = "portal";
  EvmChain2["INTAIN"] = "intain";
  EvmChain2["FUSE"] = "fuse";
  EvmChain2["ASTAR"] = "astar";
  EvmChain2["ZKSYNC"] = "zksync";
  EvmChain2["SHRAPNEL"] = "shrapnel";
  EvmChain2["DOS"] = "dos";
  EvmChain2["KLAYTN"] = "klaytn";
  EvmChain2["METIS"] = "metis";
  EvmChain2["COREDAO"] = "coredao";
  EvmChain2["OKX"] = "okx";
  EvmChain2["METER"] = "meter";
  EvmChain2["GOERLI"] = "goerli";
  EvmChain2["BASE"] = "base";
  EvmChain2["ZKCONSENSYS"] = "zkconsensys";
  EvmChain2["SEPOLIA"] = "sepolia";
  EvmChain2["MOONRIVER"] = "moonriver";
  EvmChain2["AAVEGOTCHI"] = "aavegotchi";
  EvmChain2["SCROLL"] = "scroll";
  EvmChain2["CATHAY"] = "cathay";
  EvmChain2["KAVA"] = "kava";
  EvmChain2["TENET"] = "tenet";
  EvmChain2["CANTO"] = "canto";
  EvmChain2["ORDERLY"] = "orderly";
  EvmChain2["NOVA"] = "nova";
  EvmChain2["BLOCKGEN"] = "blockgen";
  EvmChain2["MERITCIRCLE"] = "meritcircle";
  EvmChain2["MANTLE"] = "mantle";
  EvmChain2["HUBBLE"] = "hubble";
  EvmChain2["ZORA"] = "zora";
  EvmChain2["TOMO"] = "tomo";
  EvmChain2["LOOT"] = "loot";
  EvmChain2["TELOS"] = "telos";
  EvmChain2["AURORA"] = "aurora";
  EvmChain2["OPBNB"] = "opbnb";
  EvmChain2["SHIMMER"] = "shimmer";
  EvmChain2["MONAD"] = "monad";
  EvmChain2["LIF3"] = "lif3";
  EvmChain2["SPRUCE"] = "spruce";
  EvmChain2["PGJJTK"] = "pgjjtk";
  EvmChain2["ODA"] = "oda";
  EvmChain2["KIWI"] = "kiwi";
  EvmChain2["CONFLUX"] = "conflux";
  EvmChain2["EON"] = "eon";
  EvmChain2["XPLA"] = "xpla";
  EvmChain2["HOLESKY"] = "holesky";
  EvmChain2["INJECTIVE"] = "injective";
  EvmChain2["IDEX"] = "idex";
  EvmChain2["ZKATANA"] = "zkatana";
  EvmChain2["MANTA"] = "manta";
  EvmChain2["FRAME"] = "frame";
  EvmChain2["PGN"] = "pgn";
  EvmChain2["POLYGONCDK"] = "polygoncdk";
  EvmChain2["ARBSEP"] = "arbsep";
  EvmChain2["OPTSEP"] = "optsep";
  EvmChain2["BERA"] = "bera";
  EvmChain2["VENN"] = "venn";
  EvmChain2["RARIBLE"] = "rarible";
  EvmChain2["GUNZILLA"] = "gunzilla";
  EvmChain2["RC1"] = "rc1";
  EvmChain2["ETHERLINK"] = "etherlink";
  EvmChain2["KIWI2"] = "kiwi2";
  EvmChain2["BB1"] = "bb1";
  EvmChain2["JOC"] = "joc";
  EvmChain2["BLAST"] = "blast";
  EvmChain2["TRON"] = "tron";
  EvmChain2["TRONDEV"] = "trondev";
  EvmChain2["XAI"] = "xai";
  EvmChain2["TANGIBLE"] = "tangible";
  EvmChain2["BASESEP"] = "basesep";
  EvmChain2["MANTLESEP"] = "mantlesep";
  EvmChain2["ZKPOLYGONSEP"] = "zkpolygonsep";
  EvmChain2["ZKSYNCSEP"] = "zksyncsep";
  EvmChain2["ZORASEP"] = "zorasep";
  EvmChain2["EXOCORE"] = "exocore";
  EvmChain2["REAL"] = "real";
  EvmChain2["TILTYARD"] = "tiltyard";
  EvmChain2["SKALE"] = "skale";
  EvmChain2["FRAXTAL"] = "fraxtal";
  EvmChain2["SEI"] = "sei";
  EvmChain2["MODE"] = "mode";
  EvmChain2["HEDERA"] = "hedera";
  EvmChain2["UNREAL"] = "unreal";
  EvmChain2["MASA"] = "masa";
  EvmChain2["MERLIN"] = "merlin";
  EvmChain2["HOMEVERSE"] = "homeverse";
  EvmChain2["ZKASTAR"] = "zkastar";
  EvmChain2["AMOY"] = "amoy";
  EvmChain2["DEGEN"] = "degen";
  EvmChain2["XLAYER"] = "xlayer";
  EvmChain2["FORM"] = "form";
  EvmChain2["LL1"] = "ll1";
  EvmChain2["MANTASEP"] = "mantasep";
  EvmChain2["TAIKO"] = "taiko";
  EvmChain2["ZIRCUIT"] = "zircuit";
  EvmChain2["CAMP"] = "camp";
  EvmChain2["OLIVE"] = "olive";
  EvmChain2["SANKO"] = "sanko";
  EvmChain2["BOB"] = "bob";
  EvmChain2["CYBER"] = "cyber";
  EvmChain2["BOTANIX"] = "botanix";
  EvmChain2["XCHAIN"] = "xchain";
  EvmChain2["ZKLINK"] = "zklink";
  EvmChain2["EBI"] = "ebi";
  EvmChain2["KINTO"] = "kinto";
  EvmChain2["LINEASEP"] = "lineasep";
  EvmChain2["IOTA"] = "iota";
  EvmChain2["BESU1"] = "besu1";
  EvmChain2["BOUNCEBIT"] = "bouncebit";
  EvmChain2["MORPH"] = "morph";
  EvmChain2["GRAVITY"] = "gravity";
  EvmChain2["BARTIO"] = "bartio";
  EvmChain2["METISSEP"] = "metissep";
  EvmChain2["FLARE"] = "flare";
  EvmChain2["GLUE"] = "glue";
  EvmChain2["OPENCAMPUS"] = "opencampus";
  EvmChain2["VANAR"] = "vanar";
  EvmChain2["PEAQ"] = "peaq";
  EvmChain2["FI"] = "fi";
  EvmChain2["PLUME"] = "plume";
  EvmChain2["CURTIS"] = "curtis";
  EvmChain2["LYRA"] = "lyra";
  EvmChain2["LIGHTLINK"] = "lightlink";
  EvmChain2["BAHAMUT"] = "bahamut";
  EvmChain2["CODEX"] = "codex";
  EvmChain2["OTHERWORLD"] = "otherworld";
  EvmChain2["ABSTRACT"] = "abstract";
  EvmChain2["ROOT"] = "root";
  EvmChain2["STORY"] = "story";
  EvmChain2["TREASURE"] = "treasure";
  EvmChain2["REYA"] = "reya";
  EvmChain2["BITLAYER"] = "bitlayer";
  EvmChain2["DM2VERSE"] = "dm2verse";
  EvmChain2["APE"] = "ape";
  EvmChain2["OZEAN"] = "ozean";
  EvmChain2["BEVM"] = "bevm";
  EvmChain2["LISK"] = "lisk";
  EvmChain2["PLUME2"] = "plume2";
  EvmChain2["KEVNET"] = "kevnet";
  EvmChain2["BLE"] = "ble";
  EvmChain2["BL2"] = "bl2";
  EvmChain2["HYPERLIQUID"] = "hyperliquid";
  EvmChain2["UNICHAIN"] = "unichain";
  EvmChain2["MINATO"] = "minato";
  EvmChain2["WORLDCOIN"] = "worldcoin";
  EvmChain2["WORLDCHAIN"] = "worldchain";
  EvmChain2["SUPERPOSITION"] = "superposition";
  EvmChain2["HEMI"] = "hemi";
  EvmChain2["GAMESWIFT"] = "gameswift";
  EvmChain2["ODYSSEY"] = "odyssey";
  EvmChain2["SOPHON"] = "sophon";
  EvmChain2["MOKSHA"] = "moksha";
  EvmChain2["EDU"] = "edu";
  EvmChain2["CITREA"] = "citrea";
  EvmChain2["ISLANDER"] = "islander";
  EvmChain2["BL3"] = "bl3";
  EvmChain2["MP1"] = "mp1";
  EvmChain2["SONIC"] = "sonic";
  EvmChain2["ROOTSTOCK"] = "rootstock";
  EvmChain2["FLOW"] = "flow";
  EvmChain2["NIBIRU"] = "nibiru";
  EvmChain2["SWELL"] = "swell";
  EvmChain2["MEMECOREFORMICARIUM"] = "memecoreformicarium";
  EvmChain2["APEXFUSIONNEXUS"] = "apexfusionnexus";
  EvmChain2["GOAT"] = "goat";
  EvmChain2["BL4"] = "bl4";
  EvmChain2["BL5"] = "bl5";
  EvmChain2["BL6"] = "bl6";
  EvmChain2["INK"] = "ink";
  EvmChain2["SONEIUM"] = "soneium";
  EvmChain2["SPACE"] = "space";
  return EvmChain2;
})(EvmChain || {});

// src/enums/chain-initia.ts
var InitiaChain = /* @__PURE__ */ ((InitiaChain2) => {
  InitiaChain2["INITIA"] = "initia";
  return InitiaChain2;
})(InitiaChain || {});

// src/enums/chain-solana.ts
var SolanaChain = /* @__PURE__ */ ((SolanaChain2) => {
  SolanaChain2["SOLANA"] = "solana";
  return SolanaChain2;
})(SolanaChain || {});

// src/enums/chain-ton.ts
var TonChain = /* @__PURE__ */ ((TonChain2) => {
  TonChain2["TON"] = "ton";
  return TonChain2;
})(TonChain || {});

// src/enums/chain.ts
var Chain = {
  ...EvmChain,
  ...AptosChain,
  ...SolanaChain,
  ...InitiaChain,
  ...TonChain
};

// src/enums/chain-type.ts
var ChainType = /* @__PURE__ */ ((ChainType2) => {
  ChainType2["UNKNOWN"] = "unknown";
  ChainType2["EVM"] = "evm";
  ChainType2["APTOS"] = "aptos";
  ChainType2["SOLANA"] = "solana";
  ChainType2["INITIA"] = "initia";
  ChainType2["TON"] = "ton";
  return ChainType2;
})(ChainType || {});

// src/enums/endpoint-id.ts
var EndpointV2IdBase = 3e4;
var MainnetEndpointId = /* @__PURE__ */ ((MainnetEndpointId2) => {
  MainnetEndpointId2[MainnetEndpointId2["ETHEREUM_MAINNET"] = 101] = "ETHEREUM_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["BSC_MAINNET"] = 102] = "BSC_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["AVALANCHE_MAINNET"] = 106] = "AVALANCHE_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["POLYGON_MAINNET"] = 109] = "POLYGON_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["ARBITRUM_MAINNET"] = 110] = "ARBITRUM_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["OPTIMISM_MAINNET"] = 111] = "OPTIMISM_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["FANTOM_MAINNET"] = 112] = "FANTOM_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["SWIMMER_MAINNET"] = 114] = "SWIMMER_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["DFK_MAINNET"] = 115] = "DFK_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["HARMONY_MAINNET"] = 116] = "HARMONY_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["DEXALOT_MAINNET"] = 118] = "DEXALOT_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["CELO_MAINNET"] = 125] = "CELO_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["MOONBEAM_MAINNET"] = 126] = "MOONBEAM_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["INTAIN_MAINNET"] = 152] = "INTAIN_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["FUSE_MAINNET"] = 138] = "FUSE_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["GNOSIS_MAINNET"] = 145] = "GNOSIS_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["APTOS_MAINNET"] = 108] = "APTOS_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["KLAYTN_MAINNET"] = 150] = "KLAYTN_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["METIS_MAINNET"] = 151] = "METIS_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["COREDAO_MAINNET"] = 153] = "COREDAO_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["GOERLI_MAINNET"] = 154] = "GOERLI_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["OKX_MAINNET"] = 155] = "OKX_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["CANTO_MAINNET"] = 159] = "CANTO_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["ZKSYNC_MAINNET"] = 165] = "ZKSYNC_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["SHRAPNEL_MAINNET"] = 148] = "SHRAPNEL_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["DOS_MAINNET"] = 149] = "DOS_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["ZKPOLYGON_MAINNET"] = 158] = "ZKPOLYGON_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["SEPOLIA_MAINNET"] = 161] = "SEPOLIA_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["MOONRIVER_MAINNET"] = 167] = "MOONRIVER_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["SOLANA_MAINNET"] = 168] = "SOLANA_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["TENET_MAINNET"] = 173] = "TENET_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["NOVA_MAINNET"] = 175] = "NOVA_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["METER_MAINNET"] = 176] = "METER_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["KAVA_MAINNET"] = 177] = "KAVA_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["MANTLE_MAINNET"] = 181] = "MANTLE_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["HUBBLE_MAINNET"] = 182] = "HUBBLE_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["ZKCONSENSYS_MAINNET"] = 183] = "ZKCONSENSYS_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["BASE_MAINNET"] = 184] = "BASE_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["ZORA_MAINNET"] = 195] = "ZORA_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["TOMO_MAINNET"] = 196] = "TOMO_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["LOOT_MAINNET"] = 197] = "LOOT_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["MERITCIRCLE_MAINNET"] = 198] = "MERITCIRCLE_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["TELOS_MAINNET"] = 199] = "TELOS_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["OPBNB_MAINNET"] = 202] = "OPBNB_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["LIF3_MAINNET"] = 205] = "LIF3_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["ASTAR_MAINNET"] = 210] = "ASTAR_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["AURORA_MAINNET"] = 211] = "AURORA_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["CONFLUX_MAINNET"] = 212] = "CONFLUX_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["ORDERLY_MAINNET"] = 213] = "ORDERLY_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["SCROLL_MAINNET"] = 214] = "SCROLL_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["EON_MAINNET"] = 215] = "EON_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["XPLA_MAINNET"] = 216] = "XPLA_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["MANTA_MAINNET"] = 217] = "MANTA_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["PGN_MAINNET"] = 218] = "PGN_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["SHIMMER_MAINNET"] = 230] = "SHIMMER_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["BB1_MAINNET"] = 234] = "BB1_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["RARIBLE_MAINNET"] = 235] = "RARIBLE_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["XAI_MAINNET"] = 236] = "XAI_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["REAL_MAINNET"] = 237] = "REAL_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["TILTYARD_MAINNET"] = 238] = "TILTYARD_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["FRAXTAL_MAINNET"] = 255] = "FRAXTAL_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["TRON_MAINNET"] = 420] = "TRON_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["ZKATANA_MAINNET"] = 257] = "ZKATANA_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["BLAST_MAINNET"] = 243] = "BLAST_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["MODE_MAINNET"] = 260] = "MODE_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["MASA_MAINNET"] = 263] = "MASA_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["HOMEVERSE_MAINNET"] = 265] = "HOMEVERSE_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["MERLIN_MAINNET"] = 266] = "MERLIN_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["DEGEN_MAINNET"] = 267] = "DEGEN_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["SKALE_MAINNET"] = 273] = "SKALE_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["XLAYER_MAINNET"] = 274] = "XLAYER_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["SANKO_MAINNET"] = 278] = "SANKO_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["BOB_MAINNET"] = 279] = "BOB_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["SEI_MAINNET"] = 280] = "SEI_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["EBI_MAINNET"] = 282] = "EBI_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["CYBER_MAINNET"] = 283] = "CYBER_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["IOTA_MAINNET"] = 284] = "IOTA_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["KINTO_MAINNET"] = 281] = "KINTO_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["JOC_MAINNET"] = 285] = "JOC_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["TAIKO_MAINNET"] = 290] = "TAIKO_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["XCHAIN_MAINNET"] = 291] = "XCHAIN_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["ETHERLINK_MAINNET"] = 292] = "ETHERLINK_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["BOUNCEBIT_MAINNET"] = 293] = "BOUNCEBIT_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["GRAVITY_MAINNET"] = 294] = "GRAVITY_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["FLARE_MAINNET"] = 295] = "FLARE_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["ZKLINK_MAINNET"] = 301] = "ZKLINK_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["PEAQ_MAINNET"] = 302] = "PEAQ_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["ZIRCUIT_MAINNET"] = 303] = "ZIRCUIT_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["LIGHTLINK_MAINNET"] = 309] = "LIGHTLINK_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["CODEX_MAINNET"] = 323] = "CODEX_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["LYRA_MAINNET"] = 311] = "LYRA_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["APE_MAINNET"] = 312] = "APE_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["REYA_MAINNET"] = 313] = "REYA_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["BITLAYER_MAINNET"] = 314] = "BITLAYER_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["DM2VERSE_MAINNET"] = 315] = "DM2VERSE_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["HEDERA_MAINNET"] = 316] = "HEDERA_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["BEVM_MAINNET"] = 317] = "BEVM_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["PLUME_MAINNET"] = 318] = "PLUME_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["WORLDCHAIN_MAINNET"] = 319] = "WORLDCHAIN_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["UNICHAIN_MAINNET"] = 320] = "UNICHAIN_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["LISK_MAINNET"] = 321] = "LISK_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["MORPH_MAINNET"] = 322] = "MORPH_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["ABSTRACT_MAINNET"] = 324] = "ABSTRACT_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["SUPERPOSITION_MAINNET"] = 327] = "SUPERPOSITION_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["EDU_MAINNET"] = 328] = "EDU_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["HEMI_MAINNET"] = 329] = "HEMI_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["ISLANDER_MAINNET"] = 330] = "ISLANDER_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["MP1_MAINNET"] = 331] = "MP1_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["SONIC_MAINNET"] = 332] = "SONIC_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["ROOTSTOCK_MAINNET"] = 333] = "ROOTSTOCK_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["SOPHON_MAINNET"] = 334] = "SOPHON_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["SWELL_MAINNET"] = 335] = "SWELL_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["FLOW_MAINNET"] = 336] = "FLOW_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["BL4_MAINNET"] = 337] = "BL4_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["BL5_MAINNET"] = 338] = "BL5_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["INK_MAINNET"] = 339] = "INK_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["SONEIUM_MAINNET"] = 340] = "SONEIUM_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["SPACE_MAINNET"] = 341] = "SPACE_MAINNET";
  MainnetEndpointId2[MainnetEndpointId2["GLUE_MAINNET"] = 342] = "GLUE_MAINNET";
  return MainnetEndpointId2;
})(MainnetEndpointId || {});
var TestnetEndpointId = /* @__PURE__ */ ((TestnetEndpointId2) => {
  TestnetEndpointId2[TestnetEndpointId2["BSC_TESTNET"] = 10102] = "BSC_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["AVALANCHE_TESTNET"] = 10106] = "AVALANCHE_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["POLYGON_TESTNET"] = 10109] = "POLYGON_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["FANTOM_TESTNET"] = 10112] = "FANTOM_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["SWIMMER_TESTNET"] = 10130] = "SWIMMER_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["DFK_TESTNET"] = 10115] = "DFK_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["HARMONY_TESTNET"] = 10133] = "HARMONY_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["DEXALOT_TESTNET"] = 10118] = "DEXALOT_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["CELO_TESTNET"] = 10125] = "CELO_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["MOONBEAM_TESTNET"] = 10126] = "MOONBEAM_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["INTAIN_TESTNET"] = 10152] = "INTAIN_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["ETHEREUM_TESTNET"] = 10121] = "ETHEREUM_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["ARBITRUM_TESTNET"] = 10143] = "ARBITRUM_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["OPTIMISM_TESTNET"] = 10132] = "OPTIMISM_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["FUSE_TESTNET"] = 10138] = "FUSE_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["GNOSIS_TESTNET"] = 10145] = "GNOSIS_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["ZKSYNC_TESTNET"] = 10165] = "ZKSYNC_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["SHRAPNEL_TESTNET"] = 10164] = "SHRAPNEL_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["DOS_TESTNET"] = 10162] = "DOS_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["APTOS_TESTNET"] = 10108] = "APTOS_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["KLAYTN_TESTNET"] = 10150] = "KLAYTN_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["METIS_TESTNET"] = 10151] = "METIS_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["COREDAO_TESTNET"] = 10153] = "COREDAO_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["OKX_TESTNET"] = 10155] = "OKX_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["METER_TESTNET"] = 10156] = "METER_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["ZKCONSENSYS_TESTNET"] = 10157] = "ZKCONSENSYS_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["ZKPOLYGON_TESTNET"] = 10158] = "ZKPOLYGON_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["CANTO_TESTNET"] = 10159] = "CANTO_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["BASE_TESTNET"] = 10160] = "BASE_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["SEPOLIA_TESTNET"] = 10161] = "SEPOLIA_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["SOLANA_TESTNET"] = 10168] = "SOLANA_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["CATHAY_TESTNET"] = 10171] = "CATHAY_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["KAVA_TESTNET"] = 10172] = "KAVA_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["TENET_TESTNET"] = 10173] = "TENET_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["BLOCKGEN_TESTNET"] = 10177] = "BLOCKGEN_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["MERITCIRCLE_TESTNET"] = 10178] = "MERITCIRCLE_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["MANTLE_TESTNET"] = 10181] = "MANTLE_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["HUBBLE_TESTNET"] = 10182] = "HUBBLE_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["AAVEGOTCHI_TESTNET"] = 10191] = "AAVEGOTCHI_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["ZORA_TESTNET"] = 10195] = "ZORA_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["TOMO_TESTNET"] = 10196] = "TOMO_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["LOOT_TESTNET"] = 10197] = "LOOT_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["TELOS_TESTNET"] = 10199] = "TELOS_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["ORDERLY_TESTNET"] = 10200] = "ORDERLY_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["AURORA_TESTNET"] = 10201] = "AURORA_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["OPBNB_TESTNET"] = 10202] = "OPBNB_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["MONAD_TESTNET"] = 10204] = "MONAD_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["SPRUCE_TESTNET"] = 10206] = "SPRUCE_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["PGJJTK_TESTNET"] = 10207] = "PGJJTK_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["ODA_TESTNET"] = 10208] = "ODA_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["KIWI_TESTNET"] = 10209] = "KIWI_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["ASTAR_TESTNET"] = 10210] = "ASTAR_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["CONFLUX_TESTNET"] = 10211] = "CONFLUX_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["SCROLL_TESTNET"] = 10214] = "SCROLL_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["EON_TESTNET"] = 10215] = "EON_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["HOLESKY_TESTNET"] = 10217] = "HOLESKY_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["INJECTIVE_TESTNET"] = 10218] = "INJECTIVE_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["IDEX_TESTNET"] = 10219] = "IDEX_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["ZKATANA_TESTNET"] = 10220] = "ZKATANA_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["MANTA_TESTNET"] = 10221] = "MANTA_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["FRAME_TESTNET"] = 10222] = "FRAME_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["PGN_TESTNET"] = 10223] = "PGN_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["POLYGONCDK_TESTNET"] = 10224] = "POLYGONCDK_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["SHIMMER_TESTNET"] = 10230] = "SHIMMER_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["ARBSEP_TESTNET"] = 10231] = "ARBSEP_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["OPTSEP_TESTNET"] = 10232] = "OPTSEP_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["VENN_TESTNET"] = 10234] = "VENN_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["RARIBLE_TESTNET"] = 10235] = "RARIBLE_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["GUNZILLA_TESTNET"] = 10236] = "GUNZILLA_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["RC1_TESTNET"] = 10238] = "RC1_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["ETHERLINK_TESTNET"] = 10239] = "ETHERLINK_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["KIWI2_TESTNET"] = 10241] = "KIWI2_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["JOC_TESTNET"] = 10242] = "JOC_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["BLAST_TESTNET"] = 10243] = "BLAST_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["BASESEP_TESTNET"] = 10245] = "BASESEP_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["MANTLESEP_TESTNET"] = 10246] = "MANTLESEP_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["ZKPOLYGONSEP_TESTNET"] = 10247] = "ZKPOLYGONSEP_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["ZKSYNCSEP_TESTNET"] = 10248] = "ZKSYNCSEP_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["ZORASEP_TESTNET"] = 10249] = "ZORASEP_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["XAI_TESTNET"] = 10251] = "XAI_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["TANGIBLE_TESTNET"] = 10252] = "TANGIBLE_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["TRON_TESTNET"] = 10420] = "TRON_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["FRAXTAL_TESTNET"] = 10255] = "FRAXTAL_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["BERA_TESTNET"] = 10256] = "BERA_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["SEI_TESTNET"] = 10258] = "SEI_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["EXOCORE_TESTNET"] = 10259] = "EXOCORE_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["MODE_TESTNET"] = 10260] = "MODE_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["UNREAL_TESTNET"] = 10262] = "UNREAL_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["MASA_TESTNET"] = 10263] = "MASA_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["MERLIN_TESTNET"] = 10264] = "MERLIN_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["HOMEVERSE_TESTNET"] = 10265] = "HOMEVERSE_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["ZKASTAR_TESTNET"] = 10266] = "ZKASTAR_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["AMOY_TESTNET"] = 10267] = "AMOY_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["DEGEN_TESTNET"] = 10268] = "DEGEN_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["XLAYER_TESTNET"] = 10269] = "XLAYER_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["FORM_TESTNET"] = 10270] = "FORM_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["LL1_TESTNET"] = 10271] = "LL1_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["MANTASEP_TESTNET"] = 10272] = "MANTASEP_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["SKALE_TESTNET"] = 10273] = "SKALE_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["TAIKO_TESTNET"] = 10274] = "TAIKO_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["ZIRCUIT_TESTNET"] = 10275] = "ZIRCUIT_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["OLIVE_TESTNET"] = 10277] = "OLIVE_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["SANKO_TESTNET"] = 10278] = "SANKO_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["BOB_TESTNET"] = 10279] = "BOB_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["CYBER_TESTNET"] = 10280] = "CYBER_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["BOTANIX_TESTNET"] = 10281] = "BOTANIX_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["XCHAIN_TESTNET"] = 10282] = "XCHAIN_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["ZKLINK_TESTNET"] = 10283] = "ZKLINK_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["EBI_TESTNET"] = 10284] = "EBI_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["HEDERA_TESTNET"] = 10285] = "HEDERA_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["LINEASEP_TESTNET"] = 10286] = "LINEASEP_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["BESU1_TESTNET"] = 10288] = "BESU1_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["BOUNCEBIT_TESTNET"] = 10289] = "BOUNCEBIT_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["BARTIO_TESTNET"] = 10291] = "BARTIO_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["METISSEP_TESTNET"] = 10292] = "METISSEP_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["XPLA_TESTNET"] = 10216] = "XPLA_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["FLARE_TESTNET"] = 10294] = "FLARE_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["CAMP_TESTNET"] = 10295] = "CAMP_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["GLUE_TESTNET"] = 10296] = "GLUE_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["OPENCAMPUS_TESTNET"] = 10297] = "OPENCAMPUS_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["VANAR_TESTNET"] = 10298] = "VANAR_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["PEAQ_TESTNET"] = 10299] = "PEAQ_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["FI_TESTNET"] = 10301] = "FI_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["PLUME_TESTNET"] = 10304] = "PLUME_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["CURTIS_TESTNET"] = 10306] = "CURTIS_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["LIF3_TESTNET"] = 10300] = "LIF3_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["IOTA_TESTNET"] = 10307] = "IOTA_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["LYRA_TESTNET"] = 10308] = "LYRA_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["LIGHTLINK_TESTNET"] = 10309] = "LIGHTLINK_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["CODEX_TESTNET"] = 10311] = "CODEX_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["OTHERWORLD_TESTNET"] = 10337] = "OTHERWORLD_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["ABSTRACT_TESTNET"] = 10313] = "ABSTRACT_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["STORY_TESTNET"] = 10315] = "STORY_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["ROOT_TESTNET"] = 10318] = "ROOT_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["REYA_TESTNET"] = 10319] = "REYA_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["BITLAYER_TESTNET"] = 10320] = "BITLAYER_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["DM2VERSE_TESTNET"] = 10321] = "DM2VERSE_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["MORPH_TESTNET"] = 10322] = "MORPH_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["OZEAN_TESTNET"] = 10323] = "OZEAN_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["BEVM_TESTNET"] = 10324] = "BEVM_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["LISK_TESTNET"] = 10327] = "LISK_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["KEVNET_TESTNET"] = 10328] = "KEVNET_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["PLUME2_TESTNET"] = 10329] = "PLUME2_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["BLE_TESTNET"] = 10330] = "BLE_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["BL2_TESTNET"] = 10331] = "BL2_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["HYPERLIQUID_TESTNET"] = 10332] = "HYPERLIQUID_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["UNICHAIN_TESTNET"] = 10333] = "UNICHAIN_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["MINATO_TESTNET"] = 10334] = "MINATO_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["WORLDCOIN_TESTNET"] = 10335] = "WORLDCOIN_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["SUPERPOSITION_TESTNET"] = 10336] = "SUPERPOSITION_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["HEMI_TESTNET"] = 10338] = "HEMI_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["GAMESWIFT_TESTNET"] = 10339] = "GAMESWIFT_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["ODYSSEY_TESTNET"] = 10340] = "ODYSSEY_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["SOPHON_TESTNET"] = 10341] = "SOPHON_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["MOKSHA_TESTNET"] = 10342] = "MOKSHA_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["CITREA_TESTNET"] = 10344] = "CITREA_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["MP1_TESTNET"] = 10345] = "MP1_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["BL3_TESTNET"] = 10346] = "BL3_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["BAHAMUT_TESTNET"] = 10347] = "BAHAMUT_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["TREASURE_TESTNET"] = 10348] = "TREASURE_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["SONIC_TESTNET"] = 10349] = "SONIC_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["ROOTSTOCK_TESTNET"] = 10350] = "ROOTSTOCK_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["FLOW_TESTNET"] = 10351] = "FLOW_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["NIBIRU_TESTNET"] = 10352] = "NIBIRU_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["SWELL_TESTNET"] = 10353] = "SWELL_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["MEMECOREFORMICARIUM_TESTNET"] = 10354] = "MEMECOREFORMICARIUM_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["APEXFUSIONNEXUS_TESTNET"] = 10355] = "APEXFUSIONNEXUS_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["GOAT_TESTNET"] = 10356] = "GOAT_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["BL6_TESTNET"] = 10357] = "BL6_TESTNET";
  TestnetEndpointId2[TestnetEndpointId2["INK_TESTNET"] = 10358] = "INK_TESTNET";
  return TestnetEndpointId2;
})(TestnetEndpointId || {});
var SandboxEndpointId = /* @__PURE__ */ ((SandboxEndpointId2) => {
  SandboxEndpointId2[SandboxEndpointId2["BSC_SANDBOX"] = 20102] = "BSC_SANDBOX";
  SandboxEndpointId2[SandboxEndpointId2["AVALANCHE_SANDBOX"] = 20106] = "AVALANCHE_SANDBOX";
  SandboxEndpointId2[SandboxEndpointId2["POLYGON_SANDBOX"] = 20109] = "POLYGON_SANDBOX";
  SandboxEndpointId2[SandboxEndpointId2["ETHEREUM_SANDBOX"] = 20121] = "ETHEREUM_SANDBOX";
  SandboxEndpointId2[SandboxEndpointId2["APTOS_SANDBOX"] = 20008] = "APTOS_SANDBOX";
  SandboxEndpointId2[SandboxEndpointId2["OPTIMISM_SANDBOX"] = 20132] = "OPTIMISM_SANDBOX";
  SandboxEndpointId2[SandboxEndpointId2["TRON_SANDBOX"] = 20420] = "TRON_SANDBOX";
  SandboxEndpointId2[SandboxEndpointId2["TRONDEV_SANDBOX"] = 20421] = "TRONDEV_SANDBOX";
  SandboxEndpointId2[SandboxEndpointId2["ARBITRUM_SANDBOX"] = 20231] = "ARBITRUM_SANDBOX";
  SandboxEndpointId2[SandboxEndpointId2["FANTOM_SANDBOX"] = 20112] = "FANTOM_SANDBOX";
  SandboxEndpointId2[SandboxEndpointId2["METIS_SANDBOX"] = 20151] = "METIS_SANDBOX";
  return SandboxEndpointId2;
})(SandboxEndpointId || {});
var MainnetV2EndpointId = /* @__PURE__ */ ((MainnetV2EndpointId2) => {
  MainnetV2EndpointId2[MainnetV2EndpointId2["ETHEREUM_V2_MAINNET"] = 30101] = "ETHEREUM_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["BSC_V2_MAINNET"] = 30102] = "BSC_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["AVALANCHE_V2_MAINNET"] = 30106] = "AVALANCHE_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["POLYGON_V2_MAINNET"] = 30109] = "POLYGON_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["ARBITRUM_V2_MAINNET"] = 30110] = "ARBITRUM_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["OPTIMISM_V2_MAINNET"] = 30111] = "OPTIMISM_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["FANTOM_V2_MAINNET"] = 30112] = "FANTOM_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["SWIMMER_V2_MAINNET"] = 30114] = "SWIMMER_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["DFK_V2_MAINNET"] = 30115] = "DFK_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["HARMONY_V2_MAINNET"] = 30116] = "HARMONY_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["DEXALOT_V2_MAINNET"] = 30118] = "DEXALOT_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["CELO_V2_MAINNET"] = 30125] = "CELO_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["MOONBEAM_V2_MAINNET"] = 30126] = "MOONBEAM_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["INTAIN_V2_MAINNET"] = 30152] = "INTAIN_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["FUSE_V2_MAINNET"] = 30138] = "FUSE_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["GNOSIS_V2_MAINNET"] = 30145] = "GNOSIS_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["KLAYTN_V2_MAINNET"] = 30150] = "KLAYTN_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["METIS_V2_MAINNET"] = 30151] = "METIS_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["COREDAO_V2_MAINNET"] = 30153] = "COREDAO_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["GOERLI_V2_MAINNET"] = 30154] = "GOERLI_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["OKX_V2_MAINNET"] = 30155] = "OKX_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["CANTO_V2_MAINNET"] = 30159] = "CANTO_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["ZKSYNC_V2_MAINNET"] = 30165] = "ZKSYNC_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["SHRAPNEL_V2_MAINNET"] = 30148] = "SHRAPNEL_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["DOS_V2_MAINNET"] = 30149] = "DOS_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["ZKPOLYGON_V2_MAINNET"] = 30158] = "ZKPOLYGON_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["SEPOLIA_V2_MAINNET"] = 30161] = "SEPOLIA_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["MOONRIVER_V2_MAINNET"] = 30167] = "MOONRIVER_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["TENET_V2_MAINNET"] = 30173] = "TENET_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["NOVA_V2_MAINNET"] = 30175] = "NOVA_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["METER_V2_MAINNET"] = 30176] = "METER_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["KAVA_V2_MAINNET"] = 30177] = "KAVA_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["MANTLE_V2_MAINNET"] = 30181] = "MANTLE_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["HUBBLE_V2_MAINNET"] = 30182] = "HUBBLE_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["ZKCONSENSYS_V2_MAINNET"] = 30183] = "ZKCONSENSYS_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["BASE_V2_MAINNET"] = 30184] = "BASE_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["ZORA_V2_MAINNET"] = 30195] = "ZORA_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["TOMO_V2_MAINNET"] = 30196] = "TOMO_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["LOOT_V2_MAINNET"] = 30197] = "LOOT_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["MERITCIRCLE_V2_MAINNET"] = 30198] = "MERITCIRCLE_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["TELOS_V2_MAINNET"] = 30199] = "TELOS_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["OPBNB_V2_MAINNET"] = 30202] = "OPBNB_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["LIF3_V2_MAINNET"] = 30205] = "LIF3_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["ASTAR_V2_MAINNET"] = 30210] = "ASTAR_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["AURORA_V2_MAINNET"] = 30211] = "AURORA_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["CONFLUX_V2_MAINNET"] = 30212] = "CONFLUX_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["ORDERLY_V2_MAINNET"] = 30213] = "ORDERLY_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["SCROLL_V2_MAINNET"] = 30214] = "SCROLL_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["EON_V2_MAINNET"] = 30215] = "EON_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["XPLA_V2_MAINNET"] = 30216] = "XPLA_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["MANTA_V2_MAINNET"] = 30217] = "MANTA_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["PGN_V2_MAINNET"] = 30218] = "PGN_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["SHIMMER_V2_MAINNET"] = 30230] = "SHIMMER_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["BB1_V2_MAINNET"] = 30234] = "BB1_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["RARIBLE_V2_MAINNET"] = 30235] = "RARIBLE_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["XAI_V2_MAINNET"] = 30236] = "XAI_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["REAL_V2_MAINNET"] = 30237] = "REAL_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["TILTYARD_V2_MAINNET"] = 30238] = "TILTYARD_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["FRAXTAL_V2_MAINNET"] = 30255] = "FRAXTAL_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["TRON_V2_MAINNET"] = 30420] = "TRON_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["ZKATANA_V2_MAINNET"] = 30257] = "ZKATANA_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["BLAST_V2_MAINNET"] = 30243] = "BLAST_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["MODE_V2_MAINNET"] = 30260] = "MODE_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["MASA_V2_MAINNET"] = 30263] = "MASA_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["HOMEVERSE_V2_MAINNET"] = 30265] = "HOMEVERSE_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["MERLIN_V2_MAINNET"] = 30266] = "MERLIN_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["DEGEN_V2_MAINNET"] = 30267] = "DEGEN_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["SKALE_V2_MAINNET"] = 30273] = "SKALE_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["XLAYER_V2_MAINNET"] = 30274] = "XLAYER_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["SANKO_V2_MAINNET"] = 30278] = "SANKO_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["BOB_V2_MAINNET"] = 30279] = "BOB_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["SEI_V2_MAINNET"] = 30280] = "SEI_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["EBI_V2_MAINNET"] = 30282] = "EBI_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["CYBER_V2_MAINNET"] = 30283] = "CYBER_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["IOTA_V2_MAINNET"] = 30284] = "IOTA_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["SOLANA_V2_MAINNET"] = 30168] = "SOLANA_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["KINTO_V2_MAINNET"] = 30281] = "KINTO_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["JOC_V2_MAINNET"] = 30285] = "JOC_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["TAIKO_V2_MAINNET"] = 30290] = "TAIKO_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["XCHAIN_V2_MAINNET"] = 30291] = "XCHAIN_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["ETHERLINK_V2_MAINNET"] = 30292] = "ETHERLINK_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["BOUNCEBIT_V2_MAINNET"] = 30293] = "BOUNCEBIT_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["GRAVITY_V2_MAINNET"] = 30294] = "GRAVITY_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["FLARE_V2_MAINNET"] = 30295] = "FLARE_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["ZKLINK_V2_MAINNET"] = 30301] = "ZKLINK_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["PEAQ_V2_MAINNET"] = 30302] = "PEAQ_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["ZIRCUIT_V2_MAINNET"] = 30303] = "ZIRCUIT_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["LIGHTLINK_V2_MAINNET"] = 30309] = "LIGHTLINK_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["APTOS_V2_MAINNET"] = 30108] = "APTOS_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["CODEX_V2_MAINNET"] = 30323] = "CODEX_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["LYRA_V2_MAINNET"] = 30311] = "LYRA_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["APE_V2_MAINNET"] = 30312] = "APE_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["REYA_V2_MAINNET"] = 30313] = "REYA_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["BITLAYER_V2_MAINNET"] = 30314] = "BITLAYER_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["DM2VERSE_V2_MAINNET"] = 30315] = "DM2VERSE_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["INITIA_V2_MAINNET"] = 30326] = "INITIA_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["MOVEMENT_V2_MAINNET"] = 30325] = "MOVEMENT_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["HEDERA_V2_MAINNET"] = 30316] = "HEDERA_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["BEVM_V2_MAINNET"] = 30317] = "BEVM_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["PLUME_V2_MAINNET"] = 30318] = "PLUME_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["WORLDCHAIN_V2_MAINNET"] = 30319] = "WORLDCHAIN_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["UNICHAIN_V2_MAINNET"] = 30320] = "UNICHAIN_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["LISK_V2_MAINNET"] = 30321] = "LISK_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["MORPH_V2_MAINNET"] = 30322] = "MORPH_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["ABSTRACT_V2_MAINNET"] = 30324] = "ABSTRACT_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["SUPERPOSITION_V2_MAINNET"] = 30327] = "SUPERPOSITION_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["EDU_V2_MAINNET"] = 30328] = "EDU_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["TON_V2_MAINNET"] = 30343] = "TON_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["HEMI_V2_MAINNET"] = 30329] = "HEMI_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["ISLANDER_V2_MAINNET"] = 30330] = "ISLANDER_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["MP1_V2_MAINNET"] = 30331] = "MP1_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["SONIC_V2_MAINNET"] = 30332] = "SONIC_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["ROOTSTOCK_V2_MAINNET"] = 30333] = "ROOTSTOCK_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["SOPHON_V2_MAINNET"] = 30334] = "SOPHON_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["SWELL_V2_MAINNET"] = 30335] = "SWELL_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["FLOW_V2_MAINNET"] = 30336] = "FLOW_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["BL4_V2_MAINNET"] = 30337] = "BL4_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["BL5_V2_MAINNET"] = 30338] = "BL5_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["INK_V2_MAINNET"] = 30339] = "INK_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["SONEIUM_V2_MAINNET"] = 30340] = "SONEIUM_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["SPACE_V2_MAINNET"] = 30341] = "SPACE_V2_MAINNET";
  MainnetV2EndpointId2[MainnetV2EndpointId2["GLUE_V2_MAINNET"] = 30342] = "GLUE_V2_MAINNET";
  return MainnetV2EndpointId2;
})(MainnetV2EndpointId || {});
var TestnetV2EndpointId = /* @__PURE__ */ ((TestnetV2EndpointId2) => {
  TestnetV2EndpointId2[TestnetV2EndpointId2["AVALANCHE_V2_TESTNET"] = 40106] = "AVALANCHE_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["POLYGON_V2_TESTNET"] = 40109] = "POLYGON_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["ETHEREUM_V2_TESTNET"] = 40121] = "ETHEREUM_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["OPTIMISM_V2_TESTNET"] = 40132] = "OPTIMISM_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["ARBITRUM_V2_TESTNET"] = 40143] = "ARBITRUM_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["BSC_V2_TESTNET"] = 40102] = "BSC_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["FANTOM_V2_TESTNET"] = 40112] = "FANTOM_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["DFK_V2_TESTNET"] = 40115] = "DFK_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["HARMONY_V2_TESTNET"] = 40133] = "HARMONY_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["DEXALOT_V2_TESTNET"] = 40118] = "DEXALOT_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["CELO_V2_TESTNET"] = 40125] = "CELO_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["MOONBEAM_V2_TESTNET"] = 40126] = "MOONBEAM_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["FUSE_V2_TESTNET"] = 40138] = "FUSE_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["GNOSIS_V2_TESTNET"] = 40145] = "GNOSIS_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["ZKSYNC_V2_TESTNET"] = 40165] = "ZKSYNC_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["SHRAPNEL_V2_TESTNET"] = 40164] = "SHRAPNEL_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["KLAYTN_V2_TESTNET"] = 40150] = "KLAYTN_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["METIS_V2_TESTNET"] = 40151] = "METIS_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["COREDAO_V2_TESTNET"] = 40153] = "COREDAO_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["OKX_V2_TESTNET"] = 40155] = "OKX_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["METER_V2_TESTNET"] = 40156] = "METER_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["ZKCONSENSYS_V2_TESTNET"] = 40157] = "ZKCONSENSYS_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["ZKPOLYGON_V2_TESTNET"] = 40158] = "ZKPOLYGON_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["CANTO_V2_TESTNET"] = 40159] = "CANTO_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["BASE_V2_TESTNET"] = 40160] = "BASE_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["SEPOLIA_V2_TESTNET"] = 40161] = "SEPOLIA_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["AAVEGOTCHI_V2_TESTNET"] = 40179] = "AAVEGOTCHI_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["SCROLL_V2_TESTNET"] = 40170] = "SCROLL_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["CATHAY_V2_TESTNET"] = 40171] = "CATHAY_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["KAVA_V2_TESTNET"] = 40172] = "KAVA_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["TENET_V2_TESTNET"] = 40173] = "TENET_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["BLOCKGEN_V2_TESTNET"] = 40177] = "BLOCKGEN_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["MERITCIRCLE_V2_TESTNET"] = 40178] = "MERITCIRCLE_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["MANTLE_V2_TESTNET"] = 40181] = "MANTLE_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["HUBBLE_V2_TESTNET"] = 40182] = "HUBBLE_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["ZORA_V2_TESTNET"] = 40195] = "ZORA_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["TOMO_V2_TESTNET"] = 40196] = "TOMO_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["LOOT_V2_TESTNET"] = 40197] = "LOOT_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["TELOS_V2_TESTNET"] = 40199] = "TELOS_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["ORDERLY_V2_TESTNET"] = 40200] = "ORDERLY_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["AURORA_V2_TESTNET"] = 40201] = "AURORA_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["OPBNB_V2_TESTNET"] = 40202] = "OPBNB_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["SHIMMER_V2_TESTNET"] = 40203] = "SHIMMER_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["MONAD_V2_TESTNET"] = 40204] = "MONAD_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["SPRUCE_V2_TESTNET"] = 40206] = "SPRUCE_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["PGJJTK_V2_TESTNET"] = 40207] = "PGJJTK_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["ODA_V2_TESTNET"] = 40208] = "ODA_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["KIWI_V2_TESTNET"] = 40209] = "KIWI_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["ASTAR_V2_TESTNET"] = 40210] = "ASTAR_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["CONFLUX_V2_TESTNET"] = 40211] = "CONFLUX_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["EON_V2_TESTNET"] = 40215] = "EON_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["HOLESKY_V2_TESTNET"] = 40217] = "HOLESKY_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["INJECTIVE_V2_TESTNET"] = 40218] = "INJECTIVE_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["IDEX_V2_TESTNET"] = 40219] = "IDEX_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["ZKATANA_V2_TESTNET"] = 40220] = "ZKATANA_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["MANTA_V2_TESTNET"] = 40221] = "MANTA_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["FRAME_V2_TESTNET"] = 40222] = "FRAME_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["PGN_V2_TESTNET"] = 40223] = "PGN_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["POLYGONCDK_V2_TESTNET"] = 40224] = "POLYGONCDK_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["ARBSEP_V2_TESTNET"] = 40231] = "ARBSEP_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["OPTSEP_V2_TESTNET"] = 40232] = "OPTSEP_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["VENN_V2_TESTNET"] = 40234] = "VENN_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["RARIBLE_V2_TESTNET"] = 40235] = "RARIBLE_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["GUNZILLA_V2_TESTNET"] = 40236] = "GUNZILLA_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["RC1_V2_TESTNET"] = 40238] = "RC1_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["ETHERLINK_V2_TESTNET"] = 40239] = "ETHERLINK_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["KIWI2_V2_TESTNET"] = 40241] = "KIWI2_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["JOC_V2_TESTNET"] = 40242] = "JOC_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["BLAST_V2_TESTNET"] = 40243] = "BLAST_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["BASESEP_V2_TESTNET"] = 40245] = "BASESEP_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["MANTLESEP_V2_TESTNET"] = 40246] = "MANTLESEP_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["ZKPOLYGONSEP_V2_TESTNET"] = 40247] = "ZKPOLYGONSEP_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["ZORASEP_V2_TESTNET"] = 40249] = "ZORASEP_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["XAI_V2_TESTNET"] = 40251] = "XAI_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["TANGIBLE_V2_TESTNET"] = 40252] = "TANGIBLE_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["EXOCORE_V2_TESTNET"] = 40259] = "EXOCORE_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["TRON_V2_TESTNET"] = 40420] = "TRON_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["FRAXTAL_V2_TESTNET"] = 40255] = "FRAXTAL_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["BERA_V2_TESTNET"] = 40256] = "BERA_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["SEI_V2_TESTNET"] = 40258] = "SEI_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["MODE_V2_TESTNET"] = 40260] = "MODE_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["UNREAL_V2_TESTNET"] = 40262] = "UNREAL_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["MASA_V2_TESTNET"] = 40263] = "MASA_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["MERLIN_V2_TESTNET"] = 40264] = "MERLIN_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["HOMEVERSE_V2_TESTNET"] = 40265] = "HOMEVERSE_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["ZKASTAR_V2_TESTNET"] = 40266] = "ZKASTAR_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["AMOY_V2_TESTNET"] = 40267] = "AMOY_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["DEGEN_V2_TESTNET"] = 40268] = "DEGEN_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["XLAYER_V2_TESTNET"] = 40269] = "XLAYER_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["FORM_V2_TESTNET"] = 40270] = "FORM_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["LL1_V2_TESTNET"] = 40271] = "LL1_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["MANTASEP_V2_TESTNET"] = 40272] = "MANTASEP_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["SKALE_V2_TESTNET"] = 40273] = "SKALE_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["TAIKO_V2_TESTNET"] = 40274] = "TAIKO_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["ZIRCUIT_V2_TESTNET"] = 40275] = "ZIRCUIT_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["OLIVE_V2_TESTNET"] = 40277] = "OLIVE_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["SANKO_V2_TESTNET"] = 40278] = "SANKO_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["BOB_V2_TESTNET"] = 40279] = "BOB_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["CYBER_V2_TESTNET"] = 40280] = "CYBER_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["BOTANIX_V2_TESTNET"] = 40281] = "BOTANIX_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["XCHAIN_V2_TESTNET"] = 40282] = "XCHAIN_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["ZKLINK_V2_TESTNET"] = 40283] = "ZKLINK_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["EBI_V2_TESTNET"] = 40284] = "EBI_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["HEDERA_V2_TESTNET"] = 40285] = "HEDERA_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["DOS_V2_TESTNET"] = 40286] = "DOS_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["LINEASEP_V2_TESTNET"] = 40287] = "LINEASEP_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["BESU1_V2_TESTNET"] = 40288] = "BESU1_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["BOUNCEBIT_V2_TESTNET"] = 40289] = "BOUNCEBIT_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["SOLANA_V2_TESTNET"] = 40168] = "SOLANA_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["BARTIO_V2_TESTNET"] = 40291] = "BARTIO_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["METISSEP_V2_TESTNET"] = 40292] = "METISSEP_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["XPLA_V2_TESTNET"] = 40216] = "XPLA_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["FLARE_V2_TESTNET"] = 40294] = "FLARE_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["CAMP_V2_TESTNET"] = 40295] = "CAMP_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["GLUE_V2_TESTNET"] = 40296] = "GLUE_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["OPENCAMPUS_V2_TESTNET"] = 40297] = "OPENCAMPUS_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["VANAR_V2_TESTNET"] = 40298] = "VANAR_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["PEAQ_V2_TESTNET"] = 40299] = "PEAQ_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["FI_V2_TESTNET"] = 40301] = "FI_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["PLUME_V2_TESTNET"] = 40304] = "PLUME_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["ZKSYNCSEP_V2_TESTNET"] = 40305] = "ZKSYNCSEP_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["CURTIS_V2_TESTNET"] = 40306] = "CURTIS_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["LIF3_V2_TESTNET"] = 40300] = "LIF3_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["IOTA_V2_TESTNET"] = 40307] = "IOTA_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["LYRA_V2_TESTNET"] = 40308] = "LYRA_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["LIGHTLINK_V2_TESTNET"] = 40309] = "LIGHTLINK_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["CODEX_V2_TESTNET"] = 40311] = "CODEX_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["OTHERWORLD_V2_TESTNET"] = 40337] = "OTHERWORLD_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["ABSTRACT_V2_TESTNET"] = 40313] = "ABSTRACT_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["STORY_V2_TESTNET"] = 40315] = "STORY_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["APTOS_V2_TESTNET"] = 40108] = "APTOS_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["ROOT_V2_TESTNET"] = 40318] = "ROOT_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["REYA_V2_TESTNET"] = 40319] = "REYA_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["BITLAYER_V2_TESTNET"] = 40320] = "BITLAYER_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["DM2VERSE_V2_TESTNET"] = 40321] = "DM2VERSE_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["MORPH_V2_TESTNET"] = 40322] = "MORPH_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["OZEAN_V2_TESTNET"] = 40323] = "OZEAN_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["INITIA_V2_TESTNET"] = 40326] = "INITIA_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["MOVEMENT_V2_TESTNET"] = 40325] = "MOVEMENT_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["BEVM_V2_TESTNET"] = 40324] = "BEVM_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["LISK_V2_TESTNET"] = 40327] = "LISK_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["KEVNET_V2_TESTNET"] = 40328] = "KEVNET_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["PLUME2_V2_TESTNET"] = 40329] = "PLUME2_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["BLE_V2_TESTNET"] = 40330] = "BLE_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["BL2_V2_TESTNET"] = 40331] = "BL2_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["HYPERLIQUID_V2_TESTNET"] = 40332] = "HYPERLIQUID_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["UNICHAIN_V2_TESTNET"] = 40333] = "UNICHAIN_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["MINATO_V2_TESTNET"] = 40334] = "MINATO_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["WORLDCOIN_V2_TESTNET"] = 40335] = "WORLDCOIN_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["SUPERPOSITION_V2_TESTNET"] = 40336] = "SUPERPOSITION_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["HEMI_V2_TESTNET"] = 40338] = "HEMI_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["GAMESWIFT_V2_TESTNET"] = 40339] = "GAMESWIFT_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["ODYSSEY_V2_TESTNET"] = 40340] = "ODYSSEY_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["SOPHON_V2_TESTNET"] = 40341] = "SOPHON_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["MOKSHA_V2_TESTNET"] = 40342] = "MOKSHA_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["TON_V2_TESTNET"] = 40343] = "TON_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["CITREA_V2_TESTNET"] = 40344] = "CITREA_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["MP1_V2_TESTNET"] = 40345] = "MP1_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["BL3_V2_TESTNET"] = 40346] = "BL3_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["BAHAMUT_V2_TESTNET"] = 40347] = "BAHAMUT_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["TREASURE_V2_TESTNET"] = 40348] = "TREASURE_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["SONIC_V2_TESTNET"] = 40349] = "SONIC_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["ROOTSTOCK_V2_TESTNET"] = 40350] = "ROOTSTOCK_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["FLOW_V2_TESTNET"] = 40351] = "FLOW_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["NIBIRU_V2_TESTNET"] = 40352] = "NIBIRU_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["SWELL_V2_TESTNET"] = 40353] = "SWELL_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["MEMECOREFORMICARIUM_V2_TESTNET"] = 40354] = "MEMECOREFORMICARIUM_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["APEXFUSIONNEXUS_V2_TESTNET"] = 40355] = "APEXFUSIONNEXUS_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["GOAT_V2_TESTNET"] = 40356] = "GOAT_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["BL6_V2_TESTNET"] = 40357] = "BL6_V2_TESTNET";
  TestnetV2EndpointId2[TestnetV2EndpointId2["INK_V2_TESTNET"] = 40358] = "INK_V2_TESTNET";
  return TestnetV2EndpointId2;
})(TestnetV2EndpointId || {});
var SandboxV2EndpointId = /* @__PURE__ */ ((SandboxV2EndpointId2) => {
  SandboxV2EndpointId2[SandboxV2EndpointId2["ETHEREUM_V2_SANDBOX"] = 50121] = "ETHEREUM_V2_SANDBOX";
  SandboxV2EndpointId2[SandboxV2EndpointId2["POLYGON_V2_SANDBOX"] = 50109] = "POLYGON_V2_SANDBOX";
  SandboxV2EndpointId2[SandboxV2EndpointId2["SOLANA_V2_SANDBOX"] = 50168] = "SOLANA_V2_SANDBOX";
  SandboxV2EndpointId2[SandboxV2EndpointId2["BSC_V2_SANDBOX"] = 50102] = "BSC_V2_SANDBOX";
  SandboxV2EndpointId2[SandboxV2EndpointId2["AVALANCHE_V2_SANDBOX"] = 50106] = "AVALANCHE_V2_SANDBOX";
  SandboxV2EndpointId2[SandboxV2EndpointId2["OPTIMISM_V2_SANDBOX"] = 50132] = "OPTIMISM_V2_SANDBOX";
  SandboxV2EndpointId2[SandboxV2EndpointId2["METIS_V2_SANDBOX"] = 50151] = "METIS_V2_SANDBOX";
  SandboxV2EndpointId2[SandboxV2EndpointId2["APTOS_V2_SANDBOX"] = 50008] = "APTOS_V2_SANDBOX";
  SandboxV2EndpointId2[SandboxV2EndpointId2["INITIA_V2_SANDBOX"] = 50326] = "INITIA_V2_SANDBOX";
  SandboxV2EndpointId2[SandboxV2EndpointId2["MOVEMENT_V2_SANDBOX"] = 50325] = "MOVEMENT_V2_SANDBOX";
  SandboxV2EndpointId2[SandboxV2EndpointId2["TRON_V2_SANDBOX"] = 50420] = "TRON_V2_SANDBOX";
  SandboxV2EndpointId2[SandboxV2EndpointId2["TRONDEV_V2_SANDBOX"] = 50421] = "TRONDEV_V2_SANDBOX";
  SandboxV2EndpointId2[SandboxV2EndpointId2["ARBITRUM_V2_SANDBOX"] = 50143] = "ARBITRUM_V2_SANDBOX";
  SandboxV2EndpointId2[SandboxV2EndpointId2["TON_V2_SANDBOX"] = 50343] = "TON_V2_SANDBOX";
  return SandboxV2EndpointId2;
})(SandboxV2EndpointId || {});
var EndpointId = {
  ...MainnetEndpointId,
  ...TestnetEndpointId,
  ...SandboxEndpointId,
  ...MainnetV2EndpointId,
  ...TestnetV2EndpointId,
  ...SandboxV2EndpointId
};

// src/enums/environment.ts
var Environment = /* @__PURE__ */ ((Environment2) => {
  Environment2["LOCAL"] = "local";
  Environment2["DEVNET"] = "devnet";
  Environment2["TESTNET"] = "testnet";
  Environment2["MAINNET"] = "mainnet";
  return Environment2;
})(Environment || {});

// src/enums/stage.ts
var Stage = /* @__PURE__ */ ((Stage2) => {
  Stage2["MAINNET"] = "mainnet";
  Stage2["TESTNET"] = "testnet";
  Stage2["SANDBOX"] = "sandbox";
  return Stage2;
})(Stage || {});

// src/enums/endpoint-version.ts
var EndpointVersion = /* @__PURE__ */ ((EndpointVersion2) => {
  EndpointVersion2["V1"] = "v1";
  EndpointVersion2["V2"] = "v2";
  return EndpointVersion2;
})(EndpointVersion || {});

// src/enums/message-lib.ts
var MessageLibCmdRead = /* @__PURE__ */ ((MessageLibCmdRead2) => {
  MessageLibCmdRead2["V_10_0_2"] = "10.0.2";
  return MessageLibCmdRead2;
})(MessageLibCmdRead || {});
var MessageLibVersionV2 = /* @__PURE__ */ ((MessageLibVersionV22) => {
  MessageLibVersionV22["SIMPLE"] = "0.0.2";
  MessageLibVersionV22["ULTRA_LIGHT_NODE_302"] = "3.0.2";
  return MessageLibVersionV22;
})(MessageLibVersionV2 || {});
var MessageLibVersionV1 = /* @__PURE__ */ ((MessageLibVersionV12) => {
  MessageLibVersionV12["ULTRA_LIGHT_NODE_301"] = "3.0.1";
  MessageLibVersionV12["ULTRA_LIGHT_NODE_201"] = "2.0.1";
  return MessageLibVersionV12;
})(MessageLibVersionV1 || {});

// src/enums/chain-key.ts
var ChainKey = /* @__PURE__ */ ((ChainKey3) => {
  ChainKey3["ETHEREUM"] = "ethereum";
  ChainKey3["GOERLI"] = "goerli";
  ChainKey3["SEPOLIA"] = "sepolia";
  ChainKey3["BSC"] = "bsc";
  ChainKey3["BSC_TESTNET"] = "bsc-testnet";
  ChainKey3["AVALANCHE"] = "avalanche";
  ChainKey3["FUJI"] = "fuji";
  ChainKey3["POLYGON"] = "polygon";
  ChainKey3["MUMBAI"] = "mumbai";
  ChainKey3["ARBITRUM"] = "arbitrum";
  ChainKey3["ARBITURM_GOERLI"] = "arbitrum-goerli";
  ChainKey3["OPTIMISM"] = "optimism";
  ChainKey3["OPTIMISM_GOERLI"] = "optimism-goerli";
  ChainKey3["FANTOM"] = "fantom";
  ChainKey3["FANTOM_TESTNET"] = "fantom-testnet";
  ChainKey3["SWIMMER"] = "swimmer";
  ChainKey3["SWIMMER_TESTNET"] = "swimmer-testnet";
  ChainKey3["DFK"] = "dfk";
  ChainKey3["DFK_TESTNET"] = "dfk-testnet";
  ChainKey3["HARMONY"] = "harmony";
  ChainKey3["HARMONY_TESTNET"] = "harmony-testnet";
  ChainKey3["DEXALOT"] = "dexalot";
  ChainKey3["DEVALOT_TESTNET"] = "dexalot-testnet";
  ChainKey3["CELO"] = "celo";
  ChainKey3["ALFAJORES"] = "alfajores";
  ChainKey3["MOONBEAM"] = "moonbeam";
  ChainKey3["MOONBASE"] = "moonbase";
  ChainKey3["MOONRIVER"] = "moonriver";
  ChainKey3["INTAIN"] = "intain";
  ChainKey3["INTAIN_TESTNET"] = "intain-testnet";
  ChainKey3["FUSE"] = "fuse";
  ChainKey3["FUSESPARK"] = "fusespark";
  ChainKey3["GNOSIS"] = "gnosis";
  ChainKey3["CHIADO"] = "chiado";
  ChainKey3["APTOS"] = "aptos";
  ChainKey3["APTOS_TESTNET"] = "aptos-testnet";
  ChainKey3["INITIA"] = "initia";
  ChainKey3["INITIA_TESTNET"] = "initia-testnet";
  ChainKey3["MOVEMENT"] = "movement";
  ChainKey3["MOVEMENT_TESTNET"] = "movement-testnet";
  ChainKey3["KLAYTN"] = "klaytn";
  ChainKey3["KLAYTN_BAOBAB"] = "klaytn-baobab";
  ChainKey3["METIS"] = "metis";
  ChainKey3["METIS_GOERLI"] = "metis-goerli";
  ChainKey3["COREDAO"] = "coredao";
  ChainKey3["COREDAO_TESTNET"] = "coredao-testnet";
  ChainKey3["METER"] = "meter";
  ChainKey3["METER_TESTNET"] = "meter-testnet";
  ChainKey3["OKX"] = "okx";
  ChainKey3["OKX_TESTNET"] = "okx-testnet";
  ChainKey3["ZKSYNC"] = "zksync";
  ChainKey3["ZKSYNC_TESTNET"] = "zksync-testnet";
  ChainKey3["SHRAPNEL"] = "shrapnel";
  ChainKey3["SHRAPNEL_TESTNET"] = "shrapnel-testnet";
  ChainKey3["DOS"] = "dos";
  ChainKey3["DOS_TESTNET"] = "dos-testnet";
  ChainKey3["ZKEVM"] = "zkevm";
  ChainKey3["ZKEVM_TESTNET"] = "zkevm-testnet";
  ChainKey3["NOVA"] = "nova";
  ChainKey3["TENET"] = "tenet";
  ChainKey3["TENET_TESTNET"] = "tenet-testnet";
  ChainKey3["CANTO"] = "canto";
  ChainKey3["CANTO_TESTNET"] = "canto-testnet";
  ChainKey3["KAVA"] = "kava";
  ChainKey3["KAVA_TESTNET"] = "kava-testnet";
  ChainKey3["SOLANA"] = "solana";
  ChainKey3["SOLANA_TESTNET"] = "solana-testnet";
  ChainKey3["LINEA_GOERLI"] = "linea-goerli";
  ChainKey3["BASE_GOERLI"] = "base-goerli";
  ChainKey3["AAVEGOTCHI_TESTNET"] = "aavegotchi-testnet";
  ChainKey3["SCROLL"] = "scroll";
  ChainKey3["SCROLL_TESTNET"] = "scroll-testnet";
  ChainKey3["CATHAY_TESTNET"] = "cathay-testnet";
  ChainKey3["ORDERLY"] = "orderly";
  ChainKey3["ORDERLY_TESTNET"] = "orderly-testnet";
  ChainKey3["BLOCKGEN_TESTNET"] = "blockgen-testnet";
  ChainKey3["BEAM_TESTNET"] = "beam-testnet";
  ChainKey3["BEAM"] = "beam";
  ChainKey3["MANTLE"] = "mantle";
  ChainKey3["MANTLE_TESTNET"] = "mantle-testnet";
  ChainKey3["HUBBLE"] = "hubble";
  ChainKey3["HUBBLE_TESTNET"] = "hubble-testnet";
  ChainKey3["LINEA"] = "linea";
  ChainKey3["BASE"] = "base";
  ChainKey3["ZORA_TESTNET"] = "zora-testnet";
  ChainKey3["ZORA"] = "zora";
  ChainKey3["TOMO_TESTNET"] = "tomo-testnet";
  ChainKey3["TOMO"] = "tomo";
  ChainKey3["LOOT_TESTNET"] = "loot-testnet";
  ChainKey3["LOOT"] = "loot";
  ChainKey3["TELOS_TESTNET"] = "telos-testnet";
  ChainKey3["TELOS"] = "telos";
  ChainKey3["AURORA"] = "aurora";
  ChainKey3["AURORA_TESTNET"] = "aurora-testnet";
  ChainKey3["OPBNB"] = "opbnb";
  ChainKey3["OPBNB_TESTNET"] = "opbnb-testnet";
  ChainKey3["SHIMMER"] = "shimmer";
  ChainKey3["SHIMMER_TESTNET"] = "shimmer-testnet";
  ChainKey3["MONAD_TESTNET"] = "monad-testnet";
  ChainKey3["LIF3"] = "lif3";
  ChainKey3["LIF3_TESTNET"] = "lif3-testnet";
  ChainKey3["SPRUCE_TESTNET"] = "spruce-testnet";
  ChainKey3["PGJJTK_TESTNET"] = "pgjjtk-testnet";
  ChainKey3["ODA_TESTNET"] = "oda-testnet";
  ChainKey3["KIWI_TESTNET"] = "kiwi-testnet";
  ChainKey3["ASTAR"] = "astar";
  ChainKey3["ASTAR_TESTNET"] = "astar-testnet";
  ChainKey3["CONFLUX"] = "conflux";
  ChainKey3["CONFLUX_TESTNET"] = "conflux-testnet";
  ChainKey3["EON"] = "eon";
  ChainKey3["EON_TESTNET"] = "eon-testnet";
  ChainKey3["XPLA"] = "xpla";
  ChainKey3["XPLA_TESTNET"] = "xpla-testnet";
  ChainKey3["HOLESKY"] = "holesky";
  ChainKey3["INJECTIVE_TESTNET"] = "injective-testnet";
  ChainKey3["IDEX_TESTNET"] = "idex-testnet";
  ChainKey3["ZKATANA_TESTNET"] = "zkatana-testnet";
  ChainKey3["ZKATANA"] = "zkatana";
  ChainKey3["MANTA"] = "manta";
  ChainKey3["MANTA_TESTNET"] = "manta-testnet";
  ChainKey3["FRAME_TESTNET"] = "frame-testnet";
  ChainKey3["PGN"] = "pgn";
  ChainKey3["PGN_TESTNET"] = "pgn-testnet";
  ChainKey3["POLYGONCDK_TESTNET"] = "polygoncdk-testnet";
  ChainKey3["ARBITRUM_SEPOLIA"] = "arbitrum-sepolia";
  ChainKey3["OPTIMISM_SEPOLIA"] = "optimism-sepolia";
  ChainKey3["BERA_TESTNET"] = "bera-testnet";
  ChainKey3["VENN_TESTNET"] = "venn-testnet";
  ChainKey3["RARIBLE_TESTNET"] = "rarible-testnet";
  ChainKey3["GUNZILLA_TESTNET"] = "gunzilla-testnet";
  ChainKey3["RC1_TESTNET"] = "rc1-testnet";
  ChainKey3["KIWI2_TESTNET"] = "kiwi2-testnet";
  ChainKey3["BB1"] = "bb1";
  ChainKey3["RARIBLE"] = "rarible";
  ChainKey3["BLAST_TESTNET"] = "blast-testnet";
  ChainKey3["BLAST"] = "blast";
  ChainKey3["XAI_TESTNET"] = "xai-testnet";
  ChainKey3["XAI"] = "xai";
  ChainKey3["TANGIBLE_TESTNET"] = "tangible-testnet";
  ChainKey3["BASE_SEPOLIA"] = "base-sepolia";
  ChainKey3["MANTLE_SEPOLIA"] = "mantle-sepolia";
  ChainKey3["ZKPOLYGON_SEPOLIA"] = "zkpolygon-sepolia";
  ChainKey3["ZKSYNC_SEPOLIA"] = "zksync-sepolia";
  ChainKey3["ZORA_SEPOLIA"] = "zora-sepolia";
  ChainKey3["EXOCORE_TESTNET"] = "exocore-testnet";
  ChainKey3["TILTYARD"] = "tiltyard";
  ChainKey3["FRAXTAL_TESTNET"] = "fraxtal-testnet";
  ChainKey3["FRAXTAL"] = "fraxtal";
  ChainKey3["MODE_TESTNET"] = "mode-testnet";
  ChainKey3["MODE"] = "mode";
  ChainKey3["REAL"] = "real";
  ChainKey3["UNREAL_TESTNET"] = "unreal-testnet";
  ChainKey3["MASA"] = "masa";
  ChainKey3["MASA_TESTNET"] = "masa-testnet";
  ChainKey3["MERLIN_TESTNET"] = "merlin-testnet";
  ChainKey3["MERLIN"] = "merlin";
  ChainKey3["HOMEVERSE"] = "homeverse";
  ChainKey3["HOMEVERSE_TESTNET"] = "homeverse-testnet";
  ChainKey3["ZKASTAR_TESTNET"] = "zkastar-testnet";
  ChainKey3["AMOY_TESTNET"] = "amoy-testnet";
  ChainKey3["DEGEN_TESTNET"] = "degen-testnet";
  ChainKey3["DEGEN"] = "degen";
  ChainKey3["XLAYER_TESTNET"] = "xlayer-testnet";
  ChainKey3["XLAYER"] = "xlayer";
  ChainKey3["FORM_TESTNET"] = "form-testnet";
  ChainKey3["LL1_TESTNET"] = "ll1-testnet";
  ChainKey3["MANTASEP_TESTNET"] = "mantasep-testnet";
  ChainKey3["SKALE_TESTNET"] = "skale-testnet";
  ChainKey3["SKALE"] = "skale";
  ChainKey3["CAMP_TESTNET"] = "camp-testnet";
  ChainKey3["OLIVE_TESTNET"] = "olive-testnet";
  ChainKey3["SANKO_TESTNET"] = "sanko-testnet";
  ChainKey3["SANKO"] = "sanko";
  ChainKey3["BOB_TESTNET"] = "bob-testnet";
  ChainKey3["BOB"] = "bob";
  ChainKey3["ETHEREUM_SANDBOX"] = "ethereum-sandbox";
  ChainKey3["BSC_SANDBOX"] = "bsc-sandbox";
  ChainKey3["AVALANCHE_SANDBOX"] = "avalanche-sandbox";
  ChainKey3["POLYGON_SANDBOX"] = "polygon-sandbox";
  ChainKey3["APTOS_SANDBOX"] = "aptos-sandbox";
  ChainKey3["INITIA_SANDBOX"] = "initia-sandbox";
  ChainKey3["MOVEMENT_SANDBOX"] = "movement-sandbox";
  ChainKey3["OPTIMISM_SANDBOX"] = "optimism-sandbox";
  ChainKey3["TRON_SANDBOX"] = "tron-sandbox";
  ChainKey3["ARBITRUM_SANDBOX"] = "arbitrum-sandbox";
  ChainKey3["FANTOM_SANDBOX"] = "fantom-sandbox";
  ChainKey3["METIS_SANDBOX"] = "metis-sandbox";
  ChainKey3["SOLANA_SANDBOX"] = "solana-sandbox";
  ChainKey3["TON_SANDBOX"] = "ton-sandbox";
  ChainKey3["BOTANIX_TESTNET"] = "botanix-testnet";
  ChainKey3["EBI_TESTNET"] = "ebi-testnet";
  ChainKey3["TRONDEV"] = "tron-dev";
  ChainKey3["TRON_TESTNET"] = "tron-testnet";
  ChainKey3["TRON"] = "tron";
  ChainKey3["SEI"] = "sei";
  ChainKey3["SEI_TESTNET"] = "sei-testnet";
  ChainKey3["EBI"] = "ebi";
  ChainKey3["LINEASEP_TESTNET"] = "lineasep-testnet";
  ChainKey3["IOTA"] = "iota";
  ChainKey3["IOTA_TESTNET"] = "iota-testnet";
  ChainKey3["CYBER"] = "cyber";
  ChainKey3["CYBER_TESTNET"] = "cyber-testnet";
  ChainKey3["JOC"] = "joc";
  ChainKey3["JOC_TESTNET"] = "joc-testnet";
  ChainKey3["BESU1_TESTNET"] = "besu1-testnet";
  ChainKey3["MORPH_TESTNET"] = "morph-testnet";
  ChainKey3["XCHAIN_TESTNET"] = "xchain-testnet";
  ChainKey3["XCHAIN"] = "xchain";
  ChainKey3["TAIKO_TESTNET"] = "taiko-testnet";
  ChainKey3["TAIKO"] = "taiko";
  ChainKey3["KINTO"] = "kinto";
  ChainKey3["ETHERLINK_TESTNET"] = "etherlink-testnet";
  ChainKey3["ETHERLINK"] = "etherlink";
  ChainKey3["BOUNCEBIT_TESTNET"] = "bouncebit-testnet";
  ChainKey3["BOUNCEBIT"] = "bouncebit";
  ChainKey3["GRAVITY"] = "gravity";
  ChainKey3["BARTIO_TESTNET"] = "bartio";
  ChainKey3["METISSEP_TESTNET"] = "metissep-testnet";
  ChainKey3["FLARE_TESTNET"] = "flare-testnet";
  ChainKey3["FLARE"] = "flare";
  ChainKey3["GLUE_TESTNET"] = "glue-testnet";
  ChainKey3["OPENCAMPUS_TESTNET"] = "opencampus-testnet";
  ChainKey3["VANAR_TESTNET"] = "vanguard-testnet";
  ChainKey3["PEAQ_TESTNET"] = "peaq-testnet";
  ChainKey3["PEAQ"] = "peaq";
  ChainKey3["ZIRCUIT_TESTNET"] = "zircuit-testnet";
  ChainKey3["ZIRCUIT"] = "zircuit";
  ChainKey3["ZKLINK_TESTNET"] = "zklink-testnet";
  ChainKey3["ZKLINK"] = "zklink";
  ChainKey3["FI_TESTNET"] = "fi-testnet";
  ChainKey3["PLUME_TESTNET"] = "plume-testnet";
  ChainKey3["CURTIS_TESTNET"] = "curtis-testnet";
  ChainKey3["LYRA"] = "lyra";
  ChainKey3["LYRA_TESTNET"] = "lyra-testnet";
  ChainKey3["BAHAMUT_TESTNET"] = "bahamut-testnet";
  ChainKey3["CODEX"] = "codex";
  ChainKey3["CODEX_TESTNET"] = "codex-testnet";
  ChainKey3["OTHERWORLD_TESTNET"] = "otherworld-testnet";
  ChainKey3["ROOT_TESTNET"] = "root-testnet";
  ChainKey3["STORY_TESTNET"] = "story-testnet";
  ChainKey3["LIGHTLINK"] = "lightlink";
  ChainKey3["LIGHTLINK_TESTNET"] = "lightlink-testnet";
  ChainKey3["TREASURE_TESTNET"] = "treasure-testnet";
  ChainKey3["REYA_TESTNET"] = "reya-testnet";
  ChainKey3["APE"] = "ape";
  ChainKey3["REYA"] = "reya";
  ChainKey3["OZEAN_TESTNET"] = "ozean-testnet";
  ChainKey3["BITLAYER"] = "bitlayer";
  ChainKey3["BITLAYER_TESTNET"] = "bitlayer-testnet";
  ChainKey3["DM2VERSE"] = "dm2verse";
  ChainKey3["DM2VERSE_TESTNET"] = "dm2verse-testnet";
  ChainKey3["BEVM"] = "bevm";
  ChainKey3["BEVM_TESTNET"] = "bevm-testnet";
  ChainKey3["HEDERA_TESTNET"] = "hedera-testnet";
  ChainKey3["HEDERA"] = "hedera";
  ChainKey3["LISK_TESTNET"] = "lisk-testnet";
  ChainKey3["PLUME2_TESTNET"] = "plume2-testnet";
  ChainKey3["KEVNET_TESTNET"] = "kevnet-testnet";
  ChainKey3["BLE_TESTNET"] = "ble-testnet";
  ChainKey3["BL2_TESTNET"] = "bl2-testnet";
  ChainKey3["PLUME"] = "plume";
  ChainKey3["HYPERLIQUID_TESTNET"] = "hyperliquid-testnet";
  ChainKey3["UNICHAIN_TESTNET"] = "unichain-testnet";
  ChainKey3["MINATO_TESTNET"] = "minato-testnet";
  ChainKey3["WORLDCOIN_TESTNET"] = "worldcoin-testnet";
  ChainKey3["WORLDCHAIN"] = "worldchain";
  ChainKey3["UNICHAIN"] = "unichain";
  ChainKey3["LISK"] = "lisk";
  ChainKey3["MORPH"] = "morph";
  ChainKey3["ABSTRACT_TESTNET"] = "abstract-testnet";
  ChainKey3["ABSTRACT"] = "abstract";
  ChainKey3["GAMESWIFT_TESTNET"] = "gameswift-testnet";
  ChainKey3["ODYSSEY_TESTNET"] = "odyssey-testnet";
  ChainKey3["SOPHON_TESTNET"] = "sophon-testnet";
  ChainKey3["SUPERPOSITION_TESTNET"] = "superposition-testnet";
  ChainKey3["SUPERPOSITION"] = "superposition";
  ChainKey3["MOKSHA_TESTNET"] = "moksha-testnet";
  ChainKey3["EDU"] = "edu";
  ChainKey3["TON"] = "ton";
  ChainKey3["TON_TESTNET"] = "ton-testnet";
  ChainKey3["HEMI_TESTNET"] = "hemi-testnet";
  ChainKey3["HEMI"] = "hemi";
  ChainKey3["CITREA_TESTNET"] = "citrea-testnet";
  ChainKey3["ISLANDER"] = "islander";
  ChainKey3["BL3_TESTNET"] = "bl3-testnet";
  ChainKey3["MP1_TESTNET"] = "mp1-testnet";
  ChainKey3["MP1"] = "mp1";
  ChainKey3["SONIC_TESTNET"] = "sonic-testnet";
  ChainKey3["ROOTSTOCK_TESTNET"] = "rootstock-testnet";
  ChainKey3["FLOW_TESTNET"] = "flow-testnet";
  ChainKey3["NIBIRU_TESTNET"] = "nibiru-testnet";
  ChainKey3["SWELL_TESTNET"] = "swell-testnet";
  ChainKey3["SONIC"] = "sonic";
  ChainKey3["SWELL"] = "swell";
  ChainKey3["SOPHON"] = "sophon";
  ChainKey3["ROOTSTOCK"] = "rootstock";
  ChainKey3["MEMECOREFORMICARIUM_TESTNET"] = "memecoreformicarium-testnet";
  ChainKey3["APEXFUSIONNEXUS_TESTNET"] = "apexfusionnexus-testnet";
  ChainKey3["GOAT_TESTNET"] = "goat-testnet";
  ChainKey3["FLOW"] = "flow";
  ChainKey3["BL4"] = "bl4";
  ChainKey3["BL5"] = "bl5";
  ChainKey3["BL6_TESTNET"] = "bl6-testnet";
  ChainKey3["INK_TESTNET"] = "ink-testnet";
  ChainKey3["INK"] = "ink";
  ChainKey3["SONEIUM"] = "soneium";
  ChainKey3["SPACE"] = "space";
  ChainKey3["GLUE"] = "glue";
  return ChainKey3;
})(ChainKey || {});

// src/enums/channel-id.ts
var ChannelId = /* @__PURE__ */ ((ChannelId2) => {
  ChannelId2[ChannelId2["READ_CHANNEL_1"] = 4294967295] = "READ_CHANNEL_1";
  ChannelId2[ChannelId2["READ_CHANNEL_2"] = 4294967294] = "READ_CHANNEL_2";
  ChannelId2[ChannelId2["READ_CHANNEL_3"] = 4294967293] = "READ_CHANNEL_3";
  ChannelId2[ChannelId2["READ_CHANNEL_4"] = 4294967292] = "READ_CHANNEL_4";
  ChannelId2[ChannelId2["READ_CHANNEL_5"] = 4294967291] = "READ_CHANNEL_5";
  ChannelId2[ChannelId2["READ_CHANNEL_6"] = 4294967290] = "READ_CHANNEL_6";
  ChannelId2[ChannelId2["READ_CHANNEL_7"] = 4294967289] = "READ_CHANNEL_7";
  ChannelId2[ChannelId2["READ_CHANNEL_8"] = 4294967288] = "READ_CHANNEL_8";
  ChannelId2[ChannelId2["READ_CHANNEL_9"] = 4294967287] = "READ_CHANNEL_9";
  ChannelId2[ChannelId2["READ_CHANNEL_10"] = 4294967286] = "READ_CHANNEL_10";
  return ChannelId2;
})(ChannelId || {});

// src/constants/chainKey.ts
var CHAIN_KEY = {
  [EndpointId.ETHEREUM_MAINNET]: "ethereum" /* ETHEREUM */,
  [EndpointId.BSC_MAINNET]: "bsc" /* BSC */,
  [EndpointId.AVALANCHE_MAINNET]: "avalanche" /* AVALANCHE */,
  [EndpointId.POLYGON_MAINNET]: "polygon" /* POLYGON */,
  [EndpointId.ARBITRUM_MAINNET]: "arbitrum" /* ARBITRUM */,
  [EndpointId.OPTIMISM_MAINNET]: "optimism" /* OPTIMISM */,
  [EndpointId.FANTOM_MAINNET]: "fantom" /* FANTOM */,
  [EndpointId.SWIMMER_MAINNET]: "swimmer" /* SWIMMER */,
  [EndpointId.DFK_MAINNET]: "dfk" /* DFK */,
  [EndpointId.HARMONY_MAINNET]: "harmony" /* HARMONY */,
  [EndpointId.DEXALOT_MAINNET]: "dexalot" /* DEXALOT */,
  [EndpointId.CELO_MAINNET]: "celo" /* CELO */,
  [EndpointId.MOONBEAM_MAINNET]: "moonbeam" /* MOONBEAM */,
  [EndpointId.INTAIN_MAINNET]: "intain" /* INTAIN */,
  [EndpointId.FUSE_MAINNET]: "fuse" /* FUSE */,
  [EndpointId.GNOSIS_MAINNET]: "gnosis" /* GNOSIS */,
  [EndpointId.APTOS_MAINNET]: "aptos" /* APTOS */,
  [EndpointId.KLAYTN_MAINNET]: "klaytn" /* KLAYTN */,
  [EndpointId.METIS_MAINNET]: "metis" /* METIS */,
  [EndpointId.COREDAO_MAINNET]: "coredao" /* COREDAO */,
  [EndpointId.METER_MAINNET]: "meter" /* METER */,
  [EndpointId.OKX_MAINNET]: "okx" /* OKX */,
  [EndpointId.GOERLI_MAINNET]: "goerli" /* GOERLI */,
  [EndpointId.ZKSYNC_MAINNET]: "zksync" /* ZKSYNC */,
  [EndpointId.SHRAPNEL_MAINNET]: "shrapnel" /* SHRAPNEL */,
  [EndpointId.DOS_MAINNET]: "dos" /* DOS */,
  [EndpointId.ZKPOLYGON_MAINNET]: "zkevm" /* ZKEVM */,
  [EndpointId.SEPOLIA_MAINNET]: "sepolia" /* SEPOLIA */,
  [EndpointId.MOONRIVER_MAINNET]: "moonriver" /* MOONRIVER */,
  [EndpointId.NOVA_MAINNET]: "nova" /* NOVA */,
  [EndpointId.TENET_MAINNET]: "tenet" /* TENET */,
  [EndpointId.CANTO_MAINNET]: "canto" /* CANTO */,
  [EndpointId.KAVA_MAINNET]: "kava" /* KAVA */,
  [EndpointId.MANTLE_MAINNET]: "mantle" /* MANTLE */,
  [EndpointId.HUBBLE_MAINNET]: "hubble" /* HUBBLE */,
  [EndpointId.ZKCONSENSYS_MAINNET]: "linea" /* LINEA */,
  [EndpointId.BASE_MAINNET]: "base" /* BASE */,
  [EndpointId.ZORA_MAINNET]: "zora" /* ZORA */,
  [EndpointId.TOMO_MAINNET]: "tomo" /* TOMO */,
  [EndpointId.LOOT_MAINNET]: "loot" /* LOOT */,
  [EndpointId.TELOS_MAINNET]: "telos" /* TELOS */,
  [EndpointId.MERITCIRCLE_MAINNET]: "beam" /* BEAM */,
  [EndpointId.OPBNB_MAINNET]: "opbnb" /* OPBNB */,
  [EndpointId.LIF3_MAINNET]: "lif3" /* LIF3 */,
  [EndpointId.ASTAR_MAINNET]: "astar" /* ASTAR */,
  [EndpointId.AURORA_MAINNET]: "aurora" /* AURORA */,
  [EndpointId.CONFLUX_MAINNET]: "conflux" /* CONFLUX */,
  [EndpointId.ORDERLY_MAINNET]: "orderly" /* ORDERLY */,
  [EndpointId.SCROLL_MAINNET]: "scroll" /* SCROLL */,
  [EndpointId.EON_MAINNET]: "eon" /* EON */,
  [EndpointId.XPLA_MAINNET]: "xpla" /* XPLA */,
  [EndpointId.MANTA_MAINNET]: "manta" /* MANTA */,
  [EndpointId.PGN_MAINNET]: "pgn" /* PGN */,
  [EndpointId.SHIMMER_MAINNET]: "shimmer" /* SHIMMER */,
  [EndpointId.BB1_MAINNET]: "bb1" /* BB1 */,
  [EndpointId.RARIBLE_MAINNET]: "rarible" /* RARIBLE */,
  [EndpointId.XAI_MAINNET]: "xai" /* XAI */,
  [EndpointId.REAL_MAINNET]: "real" /* REAL */,
  [EndpointId.TILTYARD_MAINNET]: "tiltyard" /* TILTYARD */,
  [EndpointId.FRAXTAL_MAINNET]: "fraxtal" /* FRAXTAL */,
  [EndpointId.TRON_MAINNET]: "tron" /* TRON */,
  [EndpointId.ZKATANA_MAINNET]: "zkatana" /* ZKATANA */,
  [EndpointId.MODE_MAINNET]: "mode" /* MODE */,
  [EndpointId.BLAST_MAINNET]: "blast" /* BLAST */,
  [EndpointId.MASA_MAINNET]: "masa" /* MASA */,
  [EndpointId.HOMEVERSE_MAINNET]: "homeverse" /* HOMEVERSE */,
  [EndpointId.MERLIN_MAINNET]: "merlin" /* MERLIN */,
  [EndpointId.DEGEN_MAINNET]: "degen" /* DEGEN */,
  [EndpointId.SKALE_MAINNET]: "skale" /* SKALE */,
  [EndpointId.XLAYER_MAINNET]: "xlayer" /* XLAYER */,
  [EndpointId.BOB_MAINNET]: "bob" /* BOB */,
  [EndpointId.SANKO_MAINNET]: "sanko" /* SANKO */,
  [EndpointId.SEI_MAINNET]: "sei" /* SEI */,
  [EndpointId.KINTO_MAINNET]: "kinto" /* KINTO */,
  [EndpointId.EBI_MAINNET]: "ebi" /* EBI */,
  [EndpointId.IOTA_MAINNET]: "iota" /* IOTA */,
  [EndpointId.CYBER_MAINNET]: "cyber" /* CYBER */,
  [EndpointId.JOC_MAINNET]: "joc" /* JOC */,
  [EndpointId.SOLANA_MAINNET]: "solana" /* SOLANA */,
  [EndpointId.TAIKO_MAINNET]: "taiko" /* TAIKO */,
  [EndpointId.XCHAIN_MAINNET]: "xchain" /* XCHAIN */,
  [EndpointId.ETHERLINK_MAINNET]: "etherlink" /* ETHERLINK */,
  [EndpointId.BOUNCEBIT_MAINNET]: "bouncebit" /* BOUNCEBIT */,
  [EndpointId.GRAVITY_MAINNET]: "gravity" /* GRAVITY */,
  [EndpointId.FLARE_MAINNET]: "flare" /* FLARE */,
  [EndpointId.ZKLINK_MAINNET]: "zklink" /* ZKLINK */,
  [EndpointId.PEAQ_MAINNET]: "peaq" /* PEAQ */,
  [EndpointId.ZIRCUIT_MAINNET]: "zircuit" /* ZIRCUIT */,
  [EndpointId.LIGHTLINK_MAINNET]: "lightlink" /* LIGHTLINK */,
  [EndpointId.CODEX_MAINNET]: "codex" /* CODEX */,
  [EndpointId.LYRA_MAINNET]: "lyra" /* LYRA */,
  [EndpointId.APE_MAINNET]: "ape" /* APE */,
  [EndpointId.REYA_MAINNET]: "reya" /* REYA */,
  [EndpointId.BITLAYER_MAINNET]: "bitlayer" /* BITLAYER */,
  [EndpointId.DM2VERSE_MAINNET]: "dm2verse" /* DM2VERSE */,
  [EndpointId.HEDERA_MAINNET]: "hedera" /* HEDERA */,
  [EndpointId.BEVM_MAINNET]: "bevm" /* BEVM */,
  [EndpointId.PLUME_MAINNET]: "plume" /* PLUME */,
  [EndpointId.WORLDCHAIN_MAINNET]: "worldchain" /* WORLDCHAIN */,
  [EndpointId.UNICHAIN_MAINNET]: "unichain" /* UNICHAIN */,
  [EndpointId.LISK_MAINNET]: "lisk" /* LISK */,
  [EndpointId.MORPH_MAINNET]: "morph" /* MORPH */,
  [EndpointId.ABSTRACT_MAINNET]: "abstract" /* ABSTRACT */,
  [EndpointId.SUPERPOSITION_MAINNET]: "superposition" /* SUPERPOSITION */,
  [EndpointId.EDU_MAINNET]: "edu" /* EDU */,
  [EndpointId.HEMI_MAINNET]: "hemi" /* HEMI */,
  [EndpointId.ISLANDER_MAINNET]: "islander" /* ISLANDER */,
  [EndpointId.MP1_MAINNET]: "mp1" /* MP1 */,
  [EndpointId.SONIC_MAINNET]: "sonic" /* SONIC */,
  [EndpointId.SWELL_MAINNET]: "swell" /* SWELL */,
  [EndpointId.SOPHON_MAINNET]: "sophon" /* SOPHON */,
  [EndpointId.ROOTSTOCK_MAINNET]: "rootstock" /* ROOTSTOCK */,
  [EndpointId.FLOW_MAINNET]: "flow" /* FLOW */,
  [EndpointId.BL4_MAINNET]: "bl4" /* BL4 */,
  [EndpointId.BL5_MAINNET]: "bl5" /* BL5 */,
  [EndpointId.INK_MAINNET]: "ink" /* INK */,
  [EndpointId.SONEIUM_MAINNET]: "soneium" /* SONEIUM */,
  [EndpointId.SPACE_MAINNET]: "space" /* SPACE */,
  [EndpointId.GLUE_MAINNET]: "glue" /* GLUE */,
  // v2 mainnet
  [EndpointId.ETHEREUM_V2_MAINNET]: "ethereum" /* ETHEREUM */,
  [EndpointId.BSC_V2_MAINNET]: "bsc" /* BSC */,
  [EndpointId.AVALANCHE_V2_MAINNET]: "avalanche" /* AVALANCHE */,
  [EndpointId.POLYGON_V2_MAINNET]: "polygon" /* POLYGON */,
  [EndpointId.ARBITRUM_V2_MAINNET]: "arbitrum" /* ARBITRUM */,
  [EndpointId.OPTIMISM_V2_MAINNET]: "optimism" /* OPTIMISM */,
  [EndpointId.FANTOM_V2_MAINNET]: "fantom" /* FANTOM */,
  [EndpointId.SWIMMER_V2_MAINNET]: "swimmer" /* SWIMMER */,
  [EndpointId.DFK_V2_MAINNET]: "dfk" /* DFK */,
  [EndpointId.HARMONY_V2_MAINNET]: "harmony" /* HARMONY */,
  [EndpointId.DEXALOT_V2_MAINNET]: "dexalot" /* DEXALOT */,
  [EndpointId.CELO_V2_MAINNET]: "celo" /* CELO */,
  [EndpointId.MOONBEAM_V2_MAINNET]: "moonbeam" /* MOONBEAM */,
  [EndpointId.INTAIN_V2_MAINNET]: "intain" /* INTAIN */,
  [EndpointId.FUSE_V2_MAINNET]: "fuse" /* FUSE */,
  [EndpointId.GNOSIS_V2_MAINNET]: "gnosis" /* GNOSIS */,
  [EndpointId.KLAYTN_V2_MAINNET]: "klaytn" /* KLAYTN */,
  [EndpointId.METIS_V2_MAINNET]: "metis" /* METIS */,
  [EndpointId.COREDAO_V2_MAINNET]: "coredao" /* COREDAO */,
  [EndpointId.GOERLI_V2_MAINNET]: "goerli" /* GOERLI */,
  [EndpointId.OKX_V2_MAINNET]: "okx" /* OKX */,
  [EndpointId.CANTO_V2_MAINNET]: "canto" /* CANTO */,
  [EndpointId.ZKSYNC_V2_MAINNET]: "zksync" /* ZKSYNC */,
  [EndpointId.SHRAPNEL_V2_MAINNET]: "shrapnel" /* SHRAPNEL */,
  [EndpointId.DOS_V2_MAINNET]: "dos" /* DOS */,
  [EndpointId.ZKPOLYGON_V2_MAINNET]: "zkevm" /* ZKEVM */,
  [EndpointId.SEPOLIA_V2_MAINNET]: "sepolia" /* SEPOLIA */,
  [EndpointId.MOONRIVER_V2_MAINNET]: "moonriver" /* MOONRIVER */,
  [EndpointId.TENET_V2_MAINNET]: "tenet" /* TENET */,
  [EndpointId.NOVA_V2_MAINNET]: "nova" /* NOVA */,
  [EndpointId.METER_V2_MAINNET]: "meter" /* METER */,
  [EndpointId.KAVA_V2_MAINNET]: "kava" /* KAVA */,
  [EndpointId.MANTLE_V2_MAINNET]: "mantle" /* MANTLE */,
  [EndpointId.HUBBLE_V2_MAINNET]: "hubble" /* HUBBLE */,
  [EndpointId.ZKCONSENSYS_V2_MAINNET]: "linea" /* LINEA */,
  [EndpointId.BASE_V2_MAINNET]: "base" /* BASE */,
  [EndpointId.ZORA_V2_MAINNET]: "zora" /* ZORA */,
  [EndpointId.TOMO_V2_MAINNET]: "tomo" /* TOMO */,
  [EndpointId.LOOT_V2_MAINNET]: "loot" /* LOOT */,
  [EndpointId.TELOS_V2_MAINNET]: "telos" /* TELOS */,
  [EndpointId.MERITCIRCLE_V2_MAINNET]: "beam" /* BEAM */,
  [EndpointId.OPBNB_V2_MAINNET]: "opbnb" /* OPBNB */,
  [EndpointId.LIF3_V2_MAINNET]: "lif3" /* LIF3 */,
  [EndpointId.ASTAR_V2_MAINNET]: "astar" /* ASTAR */,
  [EndpointId.AURORA_V2_MAINNET]: "aurora" /* AURORA */,
  [EndpointId.CONFLUX_V2_MAINNET]: "conflux" /* CONFLUX */,
  [EndpointId.ORDERLY_V2_MAINNET]: "orderly" /* ORDERLY */,
  [EndpointId.SCROLL_V2_MAINNET]: "scroll" /* SCROLL */,
  [EndpointId.EON_V2_MAINNET]: "eon" /* EON */,
  [EndpointId.XPLA_V2_MAINNET]: "xpla" /* XPLA */,
  [EndpointId.MANTA_V2_MAINNET]: "manta" /* MANTA */,
  [EndpointId.PGN_V2_MAINNET]: "pgn" /* PGN */,
  [EndpointId.SHIMMER_V2_MAINNET]: "shimmer" /* SHIMMER */,
  [EndpointId.BB1_V2_MAINNET]: "bb1" /* BB1 */,
  [EndpointId.RARIBLE_V2_MAINNET]: "rarible" /* RARIBLE */,
  [EndpointId.XAI_V2_MAINNET]: "xai" /* XAI */,
  [EndpointId.REAL_V2_MAINNET]: "real" /* REAL */,
  [EndpointId.TILTYARD_V2_MAINNET]: "tiltyard" /* TILTYARD */,
  [EndpointId.FRAXTAL_V2_MAINNET]: "fraxtal" /* FRAXTAL */,
  [EndpointId.MODE_V2_MAINNET]: "mode" /* MODE */,
  [EndpointId.TRON_V2_MAINNET]: "tron" /* TRON */,
  [EndpointId.BLAST_V2_MAINNET]: "blast" /* BLAST */,
  [EndpointId.ZKATANA_V2_MAINNET]: "zkatana" /* ZKATANA */,
  [EndpointId.MASA_V2_MAINNET]: "masa" /* MASA */,
  [EndpointId.HOMEVERSE_V2_MAINNET]: "homeverse" /* HOMEVERSE */,
  [EndpointId.MERLIN_V2_MAINNET]: "merlin" /* MERLIN */,
  [EndpointId.DEGEN_V2_MAINNET]: "degen" /* DEGEN */,
  [EndpointId.SKALE_V2_MAINNET]: "skale" /* SKALE */,
  [EndpointId.XLAYER_V2_MAINNET]: "xlayer" /* XLAYER */,
  [EndpointId.BOB_V2_MAINNET]: "bob" /* BOB */,
  [EndpointId.SANKO_V2_MAINNET]: "sanko" /* SANKO */,
  [EndpointId.SEI_V2_MAINNET]: "sei" /* SEI */,
  [EndpointId.KINTO_V2_MAINNET]: "kinto" /* KINTO */,
  [EndpointId.EBI_V2_MAINNET]: "ebi" /* EBI */,
  [EndpointId.IOTA_V2_MAINNET]: "iota" /* IOTA */,
  [EndpointId.CYBER_V2_MAINNET]: "cyber" /* CYBER */,
  [EndpointId.JOC_V2_MAINNET]: "joc" /* JOC */,
  [EndpointId.SOLANA_V2_MAINNET]: "solana" /* SOLANA */,
  [EndpointId.TAIKO_V2_MAINNET]: "taiko" /* TAIKO */,
  [EndpointId.XCHAIN_V2_MAINNET]: "xchain" /* XCHAIN */,
  [EndpointId.ETHERLINK_V2_MAINNET]: "etherlink" /* ETHERLINK */,
  [EndpointId.BOUNCEBIT_V2_MAINNET]: "bouncebit" /* BOUNCEBIT */,
  [EndpointId.GRAVITY_V2_MAINNET]: "gravity" /* GRAVITY */,
  [EndpointId.FLARE_V2_MAINNET]: "flare" /* FLARE */,
  [EndpointId.ZKLINK_V2_MAINNET]: "zklink" /* ZKLINK */,
  [EndpointId.PEAQ_V2_MAINNET]: "peaq" /* PEAQ */,
  [EndpointId.ZIRCUIT_V2_MAINNET]: "zircuit" /* ZIRCUIT */,
  [EndpointId.LIGHTLINK_V2_MAINNET]: "lightlink" /* LIGHTLINK */,
  [EndpointId.APTOS_V2_MAINNET]: "aptos" /* APTOS */,
  [EndpointId.CODEX_V2_MAINNET]: "codex" /* CODEX */,
  [EndpointId.LYRA_V2_MAINNET]: "lyra" /* LYRA */,
  [EndpointId.APE_V2_MAINNET]: "ape" /* APE */,
  [EndpointId.REYA_V2_MAINNET]: "reya" /* REYA */,
  [EndpointId.BITLAYER_V2_MAINNET]: "bitlayer" /* BITLAYER */,
  [EndpointId.DM2VERSE_V2_MAINNET]: "dm2verse" /* DM2VERSE */,
  [EndpointId.INITIA_V2_MAINNET]: "initia" /* INITIA */,
  [EndpointId.MOVEMENT_V2_MAINNET]: "movement" /* MOVEMENT */,
  [EndpointId.HEDERA_V2_MAINNET]: "hedera" /* HEDERA */,
  [EndpointId.BEVM_V2_MAINNET]: "bevm" /* BEVM */,
  [EndpointId.PLUME_V2_MAINNET]: "plume" /* PLUME */,
  [EndpointId.WORLDCHAIN_V2_MAINNET]: "worldchain" /* WORLDCHAIN */,
  [EndpointId.UNICHAIN_V2_MAINNET]: "unichain" /* UNICHAIN */,
  [EndpointId.LISK_V2_MAINNET]: "lisk" /* LISK */,
  [EndpointId.MORPH_V2_MAINNET]: "morph" /* MORPH */,
  [EndpointId.ABSTRACT_V2_MAINNET]: "abstract" /* ABSTRACT */,
  [EndpointId.SUPERPOSITION_V2_MAINNET]: "superposition" /* SUPERPOSITION */,
  [EndpointId.EDU_V2_MAINNET]: "edu" /* EDU */,
  [EndpointId.HEMI_V2_MAINNET]: "hemi" /* HEMI */,
  [EndpointId.ISLANDER_V2_MAINNET]: "islander" /* ISLANDER */,
  [EndpointId.MP1_V2_MAINNET]: "mp1" /* MP1 */,
  [EndpointId.SONIC_V2_MAINNET]: "sonic" /* SONIC */,
  [EndpointId.SWELL_V2_MAINNET]: "swell" /* SWELL */,
  [EndpointId.SOPHON_V2_MAINNET]: "sophon" /* SOPHON */,
  [EndpointId.ROOTSTOCK_V2_MAINNET]: "rootstock" /* ROOTSTOCK */,
  [EndpointId.FLOW_V2_MAINNET]: "flow" /* FLOW */,
  [EndpointId.BL4_V2_MAINNET]: "bl4" /* BL4 */,
  [EndpointId.BL5_V2_MAINNET]: "bl5" /* BL5 */,
  [EndpointId.INK_V2_MAINNET]: "ink" /* INK */,
  [EndpointId.SONEIUM_V2_MAINNET]: "soneium" /* SONEIUM */,
  [EndpointId.SPACE_V2_MAINNET]: "space" /* SPACE */,
  [EndpointId.GLUE_V2_MAINNET]: "glue" /* GLUE */,
  [EndpointId.TON_V2_MAINNET]: "ton" /* TON */,
  // testnet
  [EndpointId.ETHEREUM_TESTNET]: "sepolia" /* SEPOLIA */,
  [EndpointId.BSC_TESTNET]: "bsc-testnet" /* BSC_TESTNET */,
  [EndpointId.POLYGON_TESTNET]: "mumbai" /* MUMBAI */,
  [EndpointId.FANTOM_TESTNET]: "fantom-testnet" /* FANTOM_TESTNET */,
  [EndpointId.HARMONY_TESTNET]: "harmony-testnet" /* HARMONY_TESTNET */,
  [EndpointId.AVALANCHE_TESTNET]: "fuji" /* FUJI */,
  [EndpointId.ARBITRUM_TESTNET]: "arbitrum-sepolia" /* ARBITRUM_SEPOLIA */,
  [EndpointId.OPTIMISM_TESTNET]: "optimism-sepolia" /* OPTIMISM_SEPOLIA */,
  [EndpointId.DFK_TESTNET]: "dfk-testnet" /* DFK_TESTNET */,
  [EndpointId.SWIMMER_TESTNET]: "swimmer-testnet" /* SWIMMER_TESTNET */,
  [EndpointId.DEXALOT_TESTNET]: "dexalot-testnet" /* DEVALOT_TESTNET */,
  [EndpointId.GNOSIS_TESTNET]: "chiado" /* CHIADO */,
  [EndpointId.CELO_TESTNET]: "alfajores" /* ALFAJORES */,
  [EndpointId.APTOS_TESTNET]: "aptos-testnet" /* APTOS_TESTNET */,
  [EndpointId.MOONBEAM_TESTNET]: "moonbase" /* MOONBASE */,
  [EndpointId.FUSE_TESTNET]: "fusespark" /* FUSESPARK */,
  [EndpointId.ZKSYNC_TESTNET]: "zksync-testnet" /* ZKSYNC_TESTNET */,
  [EndpointId.SHRAPNEL_TESTNET]: "shrapnel-testnet" /* SHRAPNEL_TESTNET */,
  [EndpointId.DOS_TESTNET]: "dos-testnet" /* DOS_TESTNET */,
  [EndpointId.KLAYTN_TESTNET]: "klaytn-baobab" /* KLAYTN_BAOBAB */,
  [EndpointId.METIS_TESTNET]: "metis-goerli" /* METIS_GOERLI */,
  [EndpointId.INTAIN_TESTNET]: "intain-testnet" /* INTAIN_TESTNET */,
  [EndpointId.COREDAO_TESTNET]: "coredao-testnet" /* COREDAO_TESTNET */,
  [EndpointId.ZKPOLYGON_TESTNET]: "zkevm-testnet" /* ZKEVM_TESTNET */,
  [EndpointId.OKX_TESTNET]: "okx-testnet" /* OKX_TESTNET */,
  [EndpointId.SOLANA_TESTNET]: "solana-testnet" /* SOLANA_TESTNET */,
  [EndpointId.METER_TESTNET]: "meter-testnet" /* METER_TESTNET */,
  [EndpointId.ZKCONSENSYS_TESTNET]: "linea-goerli" /* LINEA_GOERLI */,
  [EndpointId.SEPOLIA_TESTNET]: "sepolia" /* SEPOLIA */,
  [EndpointId.BASE_TESTNET]: "base-goerli" /* BASE_GOERLI */,
  [EndpointId.AAVEGOTCHI_TESTNET]: "aavegotchi-testnet" /* AAVEGOTCHI_TESTNET */,
  [EndpointId.SCROLL_TESTNET]: "scroll-testnet" /* SCROLL_TESTNET */,
  [EndpointId.CATHAY_TESTNET]: "cathay-testnet" /* CATHAY_TESTNET */,
  [EndpointId.KAVA_TESTNET]: "kava-testnet" /* KAVA_TESTNET */,
  [EndpointId.TENET_TESTNET]: "tenet-testnet" /* TENET_TESTNET */,
  [EndpointId.CANTO_TESTNET]: "canto-testnet" /* CANTO_TESTNET */,
  [EndpointId.ORDERLY_TESTNET]: "orderly-testnet" /* ORDERLY_TESTNET */,
  [EndpointId.BLOCKGEN_TESTNET]: "blockgen-testnet" /* BLOCKGEN_TESTNET */,
  [EndpointId.MERITCIRCLE_TESTNET]: "beam-testnet" /* BEAM_TESTNET */,
  [EndpointId.MANTLE_TESTNET]: "mantle-testnet" /* MANTLE_TESTNET */,
  [EndpointId.HUBBLE_TESTNET]: "hubble-testnet" /* HUBBLE_TESTNET */,
  [EndpointId.ZORA_TESTNET]: "zora-testnet" /* ZORA_TESTNET */,
  [EndpointId.TOMO_TESTNET]: "tomo-testnet" /* TOMO_TESTNET */,
  [EndpointId.LOOT_TESTNET]: "loot-testnet" /* LOOT_TESTNET */,
  [EndpointId.TELOS_TESTNET]: "telos-testnet" /* TELOS_TESTNET */,
  [EndpointId.AURORA_TESTNET]: "aurora-testnet" /* AURORA_TESTNET */,
  [EndpointId.OPBNB_TESTNET]: "opbnb-testnet" /* OPBNB_TESTNET */,
  [EndpointId.SHIMMER_TESTNET]: "shimmer-testnet" /* SHIMMER_TESTNET */,
  [EndpointId.MONAD_TESTNET]: "monad-testnet" /* MONAD_TESTNET */,
  [EndpointId.SPRUCE_TESTNET]: "spruce-testnet" /* SPRUCE_TESTNET */,
  [EndpointId.PGJJTK_TESTNET]: "pgjjtk-testnet" /* PGJJTK_TESTNET */,
  [EndpointId.ODA_TESTNET]: "oda-testnet" /* ODA_TESTNET */,
  [EndpointId.KIWI_TESTNET]: "kiwi-testnet" /* KIWI_TESTNET */,
  [EndpointId.ASTAR_TESTNET]: "astar-testnet" /* ASTAR_TESTNET */,
  [EndpointId.CONFLUX_TESTNET]: "conflux-testnet" /* CONFLUX_TESTNET */,
  [EndpointId.EON_TESTNET]: "eon-testnet" /* EON_TESTNET */,
  [EndpointId.XPLA_TESTNET]: "xpla-testnet" /* XPLA_TESTNET */,
  [EndpointId.HOLESKY_TESTNET]: "holesky" /* HOLESKY */,
  [EndpointId.INJECTIVE_TESTNET]: "injective-testnet" /* INJECTIVE_TESTNET */,
  [EndpointId.IDEX_TESTNET]: "idex-testnet" /* IDEX_TESTNET */,
  [EndpointId.ZKATANA_TESTNET]: "zkatana-testnet" /* ZKATANA_TESTNET */,
  [EndpointId.MANTA_TESTNET]: "manta-testnet" /* MANTA_TESTNET */,
  [EndpointId.FRAME_TESTNET]: "frame-testnet" /* FRAME_TESTNET */,
  [EndpointId.PGN_TESTNET]: "pgn-testnet" /* PGN_TESTNET */,
  [EndpointId.POLYGONCDK_TESTNET]: "polygoncdk-testnet" /* POLYGONCDK_TESTNET */,
  [EndpointId.ARBSEP_TESTNET]: "arbitrum-sepolia" /* ARBITRUM_SEPOLIA */,
  [EndpointId.OPTSEP_TESTNET]: "optimism-sepolia" /* OPTIMISM_SEPOLIA */,
  [EndpointId.BERA_TESTNET]: "bera-testnet" /* BERA_TESTNET */,
  [EndpointId.VENN_TESTNET]: "venn-testnet" /* VENN_TESTNET */,
  [EndpointId.RARIBLE_TESTNET]: "rarible-testnet" /* RARIBLE_TESTNET */,
  [EndpointId.GUNZILLA_TESTNET]: "gunzilla-testnet" /* GUNZILLA_TESTNET */,
  [EndpointId.RC1_TESTNET]: "rc1-testnet" /* RC1_TESTNET */,
  [EndpointId.ETHERLINK_TESTNET]: "etherlink-testnet" /* ETHERLINK_TESTNET */,
  [EndpointId.KIWI2_TESTNET]: "kiwi2-testnet" /* KIWI2_TESTNET */,
  [EndpointId.JOC_TESTNET]: "joc-testnet" /* JOC_TESTNET */,
  [EndpointId.BLAST_TESTNET]: "blast-testnet" /* BLAST_TESTNET */,
  [EndpointId.TRON_TESTNET]: "tron-testnet" /* TRON_TESTNET */,
  [EndpointId.XAI_TESTNET]: "xai-testnet" /* XAI_TESTNET */,
  [EndpointId.TANGIBLE_TESTNET]: "tangible-testnet" /* TANGIBLE_TESTNET */,
  [EndpointId.BASESEP_TESTNET]: "base-sepolia" /* BASE_SEPOLIA */,
  [EndpointId.MANTLESEP_TESTNET]: "mantle-sepolia" /* MANTLE_SEPOLIA */,
  [EndpointId.ZKPOLYGONSEP_TESTNET]: "zkpolygon-sepolia" /* ZKPOLYGON_SEPOLIA */,
  [EndpointId.ZKSYNCSEP_TESTNET]: "zksync-sepolia" /* ZKSYNC_SEPOLIA */,
  [EndpointId.ZORASEP_TESTNET]: "zora-sepolia" /* ZORA_SEPOLIA */,
  [EndpointId.EXOCORE_TESTNET]: "exocore-testnet" /* EXOCORE_TESTNET */,
  [EndpointId.FRAXTAL_TESTNET]: "fraxtal-testnet" /* FRAXTAL_TESTNET */,
  [EndpointId.SEI_TESTNET]: "sei-testnet" /* SEI_TESTNET */,
  [EndpointId.MODE_TESTNET]: "mode-testnet" /* MODE_TESTNET */,
  [EndpointId.HEDERA_TESTNET]: "hedera-testnet" /* HEDERA_TESTNET */,
  [EndpointId.UNREAL_TESTNET]: "unreal-testnet" /* UNREAL_TESTNET */,
  [EndpointId.MASA_TESTNET]: "masa-testnet" /* MASA_TESTNET */,
  [EndpointId.MERLIN_TESTNET]: "merlin-testnet" /* MERLIN_TESTNET */,
  [EndpointId.HOMEVERSE_TESTNET]: "homeverse-testnet" /* HOMEVERSE_TESTNET */,
  [EndpointId.ZKASTAR_TESTNET]: "zkastar-testnet" /* ZKASTAR_TESTNET */,
  [EndpointId.AMOY_TESTNET]: "amoy-testnet" /* AMOY_TESTNET */,
  [EndpointId.DEGEN_TESTNET]: "degen-testnet" /* DEGEN_TESTNET */,
  [EndpointId.XLAYER_TESTNET]: "xlayer-testnet" /* XLAYER_TESTNET */,
  [EndpointId.FORM_TESTNET]: "form-testnet" /* FORM_TESTNET */,
  [EndpointId.LL1_TESTNET]: "ll1-testnet" /* LL1_TESTNET */,
  [EndpointId.MANTASEP_TESTNET]: "mantasep-testnet" /* MANTASEP_TESTNET */,
  [EndpointId.SKALE_TESTNET]: "skale-testnet" /* SKALE_TESTNET */,
  [EndpointId.TAIKO_TESTNET]: "taiko-testnet" /* TAIKO_TESTNET */,
  [EndpointId.ZIRCUIT_TESTNET]: "zircuit-testnet" /* ZIRCUIT_TESTNET */,
  [EndpointId.CAMP_TESTNET]: "camp-testnet" /* CAMP_TESTNET */,
  [EndpointId.OLIVE_TESTNET]: "olive-testnet" /* OLIVE_TESTNET */,
  [EndpointId.SANKO_TESTNET]: "sanko-testnet" /* SANKO_TESTNET */,
  [EndpointId.BOB_TESTNET]: "bob-testnet" /* BOB_TESTNET */,
  [EndpointId.CYBER_TESTNET]: "cyber-testnet" /* CYBER_TESTNET */,
  [EndpointId.BOTANIX_TESTNET]: "botanix-testnet" /* BOTANIX_TESTNET */,
  [EndpointId.XCHAIN_TESTNET]: "xchain-testnet" /* XCHAIN_TESTNET */,
  [EndpointId.ZKLINK_TESTNET]: "zklink-testnet" /* ZKLINK_TESTNET */,
  [EndpointId.EBI_TESTNET]: "ebi-testnet" /* EBI_TESTNET */,
  [EndpointId.LINEASEP_TESTNET]: "lineasep-testnet" /* LINEASEP_TESTNET */,
  [EndpointId.BESU1_TESTNET]: "besu1-testnet" /* BESU1_TESTNET */,
  [EndpointId.BOUNCEBIT_TESTNET]: "bouncebit-testnet" /* BOUNCEBIT_TESTNET */,
  [EndpointId.MORPH_TESTNET]: "morph-testnet" /* MORPH_TESTNET */,
  [EndpointId.BARTIO_TESTNET]: "bartio" /* BARTIO_TESTNET */,
  [EndpointId.METISSEP_TESTNET]: "metissep-testnet" /* METISSEP_TESTNET */,
  [EndpointId.FLARE_TESTNET]: "flare-testnet" /* FLARE_TESTNET */,
  [EndpointId.GLUE_TESTNET]: "glue-testnet" /* GLUE_TESTNET */,
  [EndpointId.OPENCAMPUS_TESTNET]: "opencampus-testnet" /* OPENCAMPUS_TESTNET */,
  [EndpointId.VANAR_TESTNET]: "vanguard-testnet" /* VANAR_TESTNET */,
  [EndpointId.PEAQ_TESTNET]: "peaq-testnet" /* PEAQ_TESTNET */,
  [EndpointId.FI_TESTNET]: "fi-testnet" /* FI_TESTNET */,
  [EndpointId.PLUME_TESTNET]: "plume-testnet" /* PLUME_TESTNET */,
  [EndpointId.CURTIS_TESTNET]: "curtis-testnet" /* CURTIS_TESTNET */,
  [EndpointId.LIF3_TESTNET]: "lif3-testnet" /* LIF3_TESTNET */,
  [EndpointId.IOTA_TESTNET]: "iota-testnet" /* IOTA_TESTNET */,
  [EndpointId.LYRA_TESTNET]: "lyra-testnet" /* LYRA_TESTNET */,
  [EndpointId.LIGHTLINK_TESTNET]: "lightlink-testnet" /* LIGHTLINK_TESTNET */,
  [EndpointId.BAHAMUT_TESTNET]: "bahamut-testnet" /* BAHAMUT_TESTNET */,
  [EndpointId.CODEX_TESTNET]: "codex-testnet" /* CODEX_TESTNET */,
  [EndpointId.OTHERWORLD_TESTNET]: "otherworld-testnet" /* OTHERWORLD_TESTNET */,
  [EndpointId.ABSTRACT_TESTNET]: "abstract-testnet" /* ABSTRACT_TESTNET */,
  [EndpointId.ROOT_TESTNET]: "root-testnet" /* ROOT_TESTNET */,
  [EndpointId.STORY_TESTNET]: "story-testnet" /* STORY_TESTNET */,
  [EndpointId.TREASURE_TESTNET]: "treasure-testnet" /* TREASURE_TESTNET */,
  [EndpointId.REYA_TESTNET]: "reya-testnet" /* REYA_TESTNET */,
  [EndpointId.BITLAYER_TESTNET]: "bitlayer-testnet" /* BITLAYER_TESTNET */,
  [EndpointId.DM2VERSE_TESTNET]: "dm2verse-testnet" /* DM2VERSE_TESTNET */,
  [EndpointId.OZEAN_TESTNET]: "ozean-testnet" /* OZEAN_TESTNET */,
  [EndpointId.BEVM_TESTNET]: "bevm-testnet" /* BEVM_TESTNET */,
  [EndpointId.LISK_TESTNET]: "lisk-testnet" /* LISK_TESTNET */,
  [EndpointId.PLUME2_TESTNET]: "plume2-testnet" /* PLUME2_TESTNET */,
  [EndpointId.KEVNET_TESTNET]: "kevnet-testnet" /* KEVNET_TESTNET */,
  [EndpointId.BLE_TESTNET]: "ble-testnet" /* BLE_TESTNET */,
  [EndpointId.BL2_TESTNET]: "bl2-testnet" /* BL2_TESTNET */,
  [EndpointId.HYPERLIQUID_TESTNET]: "hyperliquid-testnet" /* HYPERLIQUID_TESTNET */,
  [EndpointId.UNICHAIN_TESTNET]: "unichain-testnet" /* UNICHAIN_TESTNET */,
  [EndpointId.MINATO_TESTNET]: "minato-testnet" /* MINATO_TESTNET */,
  [EndpointId.WORLDCOIN_TESTNET]: "worldcoin-testnet" /* WORLDCOIN_TESTNET */,
  [EndpointId.SUPERPOSITION_TESTNET]: "superposition-testnet" /* SUPERPOSITION_TESTNET */,
  [EndpointId.HEMI_TESTNET]: "hemi-testnet" /* HEMI_TESTNET */,
  [EndpointId.GAMESWIFT_TESTNET]: "gameswift-testnet" /* GAMESWIFT_TESTNET */,
  [EndpointId.ODYSSEY_TESTNET]: "odyssey-testnet" /* ODYSSEY_TESTNET */,
  [EndpointId.SOPHON_TESTNET]: "sophon-testnet" /* SOPHON_TESTNET */,
  [EndpointId.MOKSHA_TESTNET]: "moksha-testnet" /* MOKSHA_TESTNET */,
  [EndpointId.CITREA_TESTNET]: "citrea-testnet" /* CITREA_TESTNET */,
  [EndpointId.BL3_TESTNET]: "bl3-testnet" /* BL3_TESTNET */,
  [EndpointId.MP1_TESTNET]: "mp1-testnet" /* MP1_TESTNET */,
  [EndpointId.SONIC_TESTNET]: "sonic-testnet" /* SONIC_TESTNET */,
  [EndpointId.ROOTSTOCK_TESTNET]: "rootstock-testnet" /* ROOTSTOCK_TESTNET */,
  [EndpointId.FLOW_TESTNET]: "flow-testnet" /* FLOW_TESTNET */,
  [EndpointId.NIBIRU_TESTNET]: "nibiru-testnet" /* NIBIRU_TESTNET */,
  [EndpointId.SWELL_TESTNET]: "swell-testnet" /* SWELL_TESTNET */,
  [EndpointId.MEMECOREFORMICARIUM_TESTNET]: "memecoreformicarium-testnet" /* MEMECOREFORMICARIUM_TESTNET */,
  [EndpointId.APEXFUSIONNEXUS_TESTNET]: "apexfusionnexus-testnet" /* APEXFUSIONNEXUS_TESTNET */,
  [EndpointId.GOAT_TESTNET]: "goat-testnet" /* GOAT_TESTNET */,
  [EndpointId.BL6_TESTNET]: "bl6-testnet" /* BL6_TESTNET */,
  [EndpointId.INK_TESTNET]: "ink-testnet" /* INK_TESTNET */,
  // v2 testnet
  [EndpointId.ETHEREUM_V2_TESTNET]: "sepolia" /* SEPOLIA */,
  [EndpointId.POLYGON_V2_TESTNET]: "mumbai" /* MUMBAI */,
  [EndpointId.ARBITRUM_V2_TESTNET]: "arbitrum-sepolia" /* ARBITRUM_SEPOLIA */,
  [EndpointId.OPTIMISM_V2_TESTNET]: "optimism-sepolia" /* OPTIMISM_SEPOLIA */,
  [EndpointId.AVALANCHE_V2_TESTNET]: "fuji" /* FUJI */,
  [EndpointId.BSC_V2_TESTNET]: "bsc-testnet" /* BSC_TESTNET */,
  [EndpointId.FANTOM_V2_TESTNET]: "fantom-testnet" /* FANTOM_TESTNET */,
  [EndpointId.DFK_V2_TESTNET]: "dfk-testnet" /* DFK_TESTNET */,
  [EndpointId.HARMONY_V2_TESTNET]: "harmony-testnet" /* HARMONY_TESTNET */,
  [EndpointId.DEXALOT_V2_TESTNET]: "dexalot-testnet" /* DEVALOT_TESTNET */,
  [EndpointId.CELO_V2_TESTNET]: "alfajores" /* ALFAJORES */,
  [EndpointId.MOONBEAM_V2_TESTNET]: "moonbase" /* MOONBASE */,
  [EndpointId.FUSE_V2_TESTNET]: "fusespark" /* FUSESPARK */,
  [EndpointId.GNOSIS_V2_TESTNET]: "chiado" /* CHIADO */,
  [EndpointId.ZKSYNC_V2_TESTNET]: "zksync-testnet" /* ZKSYNC_TESTNET */,
  [EndpointId.SHRAPNEL_V2_TESTNET]: "shrapnel-testnet" /* SHRAPNEL_TESTNET */,
  [EndpointId.DOS_V2_TESTNET]: "dos-testnet" /* DOS_TESTNET */,
  [EndpointId.KLAYTN_V2_TESTNET]: "klaytn-baobab" /* KLAYTN_BAOBAB */,
  [EndpointId.METIS_V2_TESTNET]: "metis-goerli" /* METIS_GOERLI */,
  [EndpointId.COREDAO_V2_TESTNET]: "coredao-testnet" /* COREDAO_TESTNET */,
  [EndpointId.OKX_V2_TESTNET]: "okx-testnet" /* OKX_TESTNET */,
  [EndpointId.METER_V2_TESTNET]: "meter-testnet" /* METER_TESTNET */,
  [EndpointId.ZKCONSENSYS_V2_TESTNET]: "linea-goerli" /* LINEA_GOERLI */,
  [EndpointId.ZKPOLYGON_V2_TESTNET]: "zkevm-testnet" /* ZKEVM_TESTNET */,
  [EndpointId.CANTO_V2_TESTNET]: "canto-testnet" /* CANTO_TESTNET */,
  [EndpointId.BASE_V2_TESTNET]: "base-goerli" /* BASE_GOERLI */,
  [EndpointId.SEPOLIA_V2_TESTNET]: "sepolia" /* SEPOLIA */,
  [EndpointId.AAVEGOTCHI_V2_TESTNET]: "aavegotchi-testnet" /* AAVEGOTCHI_TESTNET */,
  [EndpointId.SCROLL_V2_TESTNET]: "scroll-testnet" /* SCROLL_TESTNET */,
  [EndpointId.CATHAY_V2_TESTNET]: "cathay-testnet" /* CATHAY_TESTNET */,
  [EndpointId.KAVA_V2_TESTNET]: "kava-testnet" /* KAVA_TESTNET */,
  [EndpointId.TENET_V2_TESTNET]: "tenet-testnet" /* TENET_TESTNET */,
  [EndpointId.ORDERLY_V2_TESTNET]: "orderly-testnet" /* ORDERLY_TESTNET */,
  [EndpointId.BLOCKGEN_V2_TESTNET]: "blockgen-testnet" /* BLOCKGEN_TESTNET */,
  [EndpointId.MERITCIRCLE_V2_TESTNET]: "beam-testnet" /* BEAM_TESTNET */,
  [EndpointId.MANTLE_V2_TESTNET]: "mantle-testnet" /* MANTLE_TESTNET */,
  [EndpointId.HUBBLE_V2_TESTNET]: "hubble-testnet" /* HUBBLE_TESTNET */,
  [EndpointId.ZORA_V2_TESTNET]: "zora-testnet" /* ZORA_TESTNET */,
  [EndpointId.TOMO_V2_TESTNET]: "tomo-testnet" /* TOMO_TESTNET */,
  [EndpointId.LOOT_V2_TESTNET]: "loot-testnet" /* LOOT_TESTNET */,
  [EndpointId.TELOS_V2_TESTNET]: "telos-testnet" /* TELOS_TESTNET */,
  [EndpointId.AURORA_V2_TESTNET]: "aurora-testnet" /* AURORA_TESTNET */,
  [EndpointId.OPBNB_V2_TESTNET]: "opbnb-testnet" /* OPBNB_TESTNET */,
  [EndpointId.SHIMMER_V2_TESTNET]: "shimmer-testnet" /* SHIMMER_TESTNET */,
  [EndpointId.MONAD_V2_TESTNET]: "monad-testnet" /* MONAD_TESTNET */,
  [EndpointId.SPRUCE_V2_TESTNET]: "spruce-testnet" /* SPRUCE_TESTNET */,
  [EndpointId.PGJJTK_V2_TESTNET]: "pgjjtk-testnet" /* PGJJTK_TESTNET */,
  [EndpointId.ODA_V2_TESTNET]: "oda-testnet" /* ODA_TESTNET */,
  [EndpointId.KIWI_V2_TESTNET]: "kiwi-testnet" /* KIWI_TESTNET */,
  [EndpointId.ASTAR_V2_TESTNET]: "astar-testnet" /* ASTAR_TESTNET */,
  [EndpointId.CONFLUX_V2_TESTNET]: "conflux-testnet" /* CONFLUX_TESTNET */,
  [EndpointId.EON_V2_TESTNET]: "eon-testnet" /* EON_TESTNET */,
  [EndpointId.XPLA_V2_TESTNET]: "xpla-testnet" /* XPLA_TESTNET */,
  [EndpointId.HOLESKY_V2_TESTNET]: "holesky" /* HOLESKY */,
  [EndpointId.INJECTIVE_V2_TESTNET]: "injective-testnet" /* INJECTIVE_TESTNET */,
  [EndpointId.IDEX_V2_TESTNET]: "idex-testnet" /* IDEX_TESTNET */,
  [EndpointId.ZKATANA_V2_TESTNET]: "zkatana-testnet" /* ZKATANA_TESTNET */,
  [EndpointId.MANTA_V2_TESTNET]: "manta-testnet" /* MANTA_TESTNET */,
  [EndpointId.FRAME_V2_TESTNET]: "frame-testnet" /* FRAME_TESTNET */,
  [EndpointId.PGN_V2_TESTNET]: "pgn-testnet" /* PGN_TESTNET */,
  [EndpointId.POLYGONCDK_V2_TESTNET]: "polygoncdk-testnet" /* POLYGONCDK_TESTNET */,
  [EndpointId.ARBSEP_V2_TESTNET]: "arbitrum-sepolia" /* ARBITRUM_SEPOLIA */,
  [EndpointId.OPTSEP_V2_TESTNET]: "optimism-sepolia" /* OPTIMISM_SEPOLIA */,
  [EndpointId.BERA_V2_TESTNET]: "bera-testnet" /* BERA_TESTNET */,
  [EndpointId.VENN_V2_TESTNET]: "venn-testnet" /* VENN_TESTNET */,
  [EndpointId.RARIBLE_V2_TESTNET]: "rarible-testnet" /* RARIBLE_TESTNET */,
  [EndpointId.GUNZILLA_V2_TESTNET]: "gunzilla-testnet" /* GUNZILLA_TESTNET */,
  [EndpointId.RC1_V2_TESTNET]: "rc1-testnet" /* RC1_TESTNET */,
  [EndpointId.ETHERLINK_V2_TESTNET]: "etherlink-testnet" /* ETHERLINK_TESTNET */,
  [EndpointId.KIWI2_V2_TESTNET]: "kiwi2-testnet" /* KIWI2_TESTNET */,
  [EndpointId.JOC_V2_TESTNET]: "joc-testnet" /* JOC_TESTNET */,
  [EndpointId.BLAST_V2_TESTNET]: "blast-testnet" /* BLAST_TESTNET */,
  [EndpointId.XAI_V2_TESTNET]: "xai-testnet" /* XAI_TESTNET */,
  [EndpointId.TANGIBLE_V2_TESTNET]: "tangible-testnet" /* TANGIBLE_TESTNET */,
  [EndpointId.BASESEP_V2_TESTNET]: "base-sepolia" /* BASE_SEPOLIA */,
  [EndpointId.MANTLESEP_V2_TESTNET]: "mantle-sepolia" /* MANTLE_SEPOLIA */,
  [EndpointId.ZKPOLYGONSEP_V2_TESTNET]: "zkpolygon-sepolia" /* ZKPOLYGON_SEPOLIA */,
  [EndpointId.ZKSYNCSEP_V2_TESTNET]: "zksync-sepolia" /* ZKSYNC_SEPOLIA */,
  [EndpointId.ZORASEP_V2_TESTNET]: "zora-sepolia" /* ZORA_SEPOLIA */,
  [EndpointId.TRON_V2_TESTNET]: "tron-testnet" /* TRON_TESTNET */,
  [EndpointId.EXOCORE_V2_TESTNET]: "exocore-testnet" /* EXOCORE_TESTNET */,
  [EndpointId.FRAXTAL_V2_TESTNET]: "fraxtal-testnet" /* FRAXTAL_TESTNET */,
  [EndpointId.SEI_V2_TESTNET]: "sei-testnet" /* SEI_TESTNET */,
  [EndpointId.MODE_V2_TESTNET]: "mode-testnet" /* MODE_TESTNET */,
  [EndpointId.HEDERA_V2_TESTNET]: "hedera-testnet" /* HEDERA_TESTNET */,
  [EndpointId.UNREAL_V2_TESTNET]: "unreal-testnet" /* UNREAL_TESTNET */,
  [EndpointId.MASA_V2_TESTNET]: "masa-testnet" /* MASA_TESTNET */,
  [EndpointId.MERLIN_V2_TESTNET]: "merlin-testnet" /* MERLIN_TESTNET */,
  [EndpointId.HOMEVERSE_V2_TESTNET]: "homeverse-testnet" /* HOMEVERSE_TESTNET */,
  [EndpointId.ZKASTAR_V2_TESTNET]: "zkastar-testnet" /* ZKASTAR_TESTNET */,
  [EndpointId.AMOY_V2_TESTNET]: "amoy-testnet" /* AMOY_TESTNET */,
  [EndpointId.DEGEN_V2_TESTNET]: "degen-testnet" /* DEGEN_TESTNET */,
  [EndpointId.XLAYER_V2_TESTNET]: "xlayer-testnet" /* XLAYER_TESTNET */,
  [EndpointId.FORM_V2_TESTNET]: "form-testnet" /* FORM_TESTNET */,
  [EndpointId.LL1_V2_TESTNET]: "ll1-testnet" /* LL1_TESTNET */,
  [EndpointId.MANTASEP_V2_TESTNET]: "mantasep-testnet" /* MANTASEP_TESTNET */,
  [EndpointId.SKALE_V2_TESTNET]: "skale-testnet" /* SKALE_TESTNET */,
  [EndpointId.TAIKO_V2_TESTNET]: "taiko-testnet" /* TAIKO_TESTNET */,
  [EndpointId.ZIRCUIT_V2_TESTNET]: "zircuit-testnet" /* ZIRCUIT_TESTNET */,
  [EndpointId.CAMP_V2_TESTNET]: "camp-testnet" /* CAMP_TESTNET */,
  [EndpointId.OLIVE_V2_TESTNET]: "olive-testnet" /* OLIVE_TESTNET */,
  [EndpointId.SANKO_V2_TESTNET]: "sanko-testnet" /* SANKO_TESTNET */,
  [EndpointId.BOB_V2_TESTNET]: "bob-testnet" /* BOB_TESTNET */,
  [EndpointId.CYBER_V2_TESTNET]: "cyber-testnet" /* CYBER_TESTNET */,
  [EndpointId.BOTANIX_V2_TESTNET]: "botanix-testnet" /* BOTANIX_TESTNET */,
  [EndpointId.XCHAIN_V2_TESTNET]: "xchain-testnet" /* XCHAIN_TESTNET */,
  [EndpointId.ZKLINK_V2_TESTNET]: "zklink-testnet" /* ZKLINK_TESTNET */,
  [EndpointId.EBI_V2_TESTNET]: "ebi-testnet" /* EBI_TESTNET */,
  [EndpointId.LINEASEP_V2_TESTNET]: "lineasep-testnet" /* LINEASEP_TESTNET */,
  [EndpointId.BESU1_V2_TESTNET]: "besu1-testnet" /* BESU1_TESTNET */,
  [EndpointId.BOUNCEBIT_V2_TESTNET]: "bouncebit-testnet" /* BOUNCEBIT_TESTNET */,
  [EndpointId.MORPH_V2_TESTNET]: "morph-testnet" /* MORPH_TESTNET */,
  [EndpointId.BARTIO_V2_TESTNET]: "bartio" /* BARTIO_TESTNET */,
  [EndpointId.METISSEP_V2_TESTNET]: "metissep-testnet" /* METISSEP_TESTNET */,
  [EndpointId.FLARE_V2_TESTNET]: "flare-testnet" /* FLARE_TESTNET */,
  [EndpointId.GLUE_V2_TESTNET]: "glue-testnet" /* GLUE_TESTNET */,
  [EndpointId.OPENCAMPUS_V2_TESTNET]: "opencampus-testnet" /* OPENCAMPUS_TESTNET */,
  [EndpointId.VANAR_V2_TESTNET]: "vanguard-testnet" /* VANAR_TESTNET */,
  [EndpointId.PEAQ_V2_TESTNET]: "peaq-testnet" /* PEAQ_TESTNET */,
  [EndpointId.FI_V2_TESTNET]: "fi-testnet" /* FI_TESTNET */,
  [EndpointId.PLUME_V2_TESTNET]: "plume-testnet" /* PLUME_TESTNET */,
  [EndpointId.CURTIS_V2_TESTNET]: "curtis-testnet" /* CURTIS_TESTNET */,
  [EndpointId.LIF3_V2_TESTNET]: "lif3-testnet" /* LIF3_TESTNET */,
  [EndpointId.IOTA_V2_TESTNET]: "iota-testnet" /* IOTA_TESTNET */,
  [EndpointId.LYRA_V2_TESTNET]: "lyra-testnet" /* LYRA_TESTNET */,
  [EndpointId.LIGHTLINK_V2_TESTNET]: "lightlink-testnet" /* LIGHTLINK_TESTNET */,
  [EndpointId.BAHAMUT_V2_TESTNET]: "bahamut-testnet" /* BAHAMUT_TESTNET */,
  [EndpointId.CODEX_V2_TESTNET]: "codex-testnet" /* CODEX_TESTNET */,
  [EndpointId.OTHERWORLD_V2_TESTNET]: "otherworld-testnet" /* OTHERWORLD_TESTNET */,
  [EndpointId.ABSTRACT_V2_TESTNET]: "abstract-testnet" /* ABSTRACT_TESTNET */,
  [EndpointId.ROOT_V2_TESTNET]: "root-testnet" /* ROOT_TESTNET */,
  [EndpointId.STORY_V2_TESTNET]: "story-testnet" /* STORY_TESTNET */,
  [EndpointId.TREASURE_V2_TESTNET]: "treasure-testnet" /* TREASURE_TESTNET */,
  [EndpointId.REYA_V2_TESTNET]: "reya-testnet" /* REYA_TESTNET */,
  [EndpointId.BITLAYER_V2_TESTNET]: "bitlayer-testnet" /* BITLAYER_TESTNET */,
  [EndpointId.DM2VERSE_V2_TESTNET]: "dm2verse-testnet" /* DM2VERSE_TESTNET */,
  [EndpointId.OZEAN_V2_TESTNET]: "ozean-testnet" /* OZEAN_TESTNET */,
  [EndpointId.BEVM_V2_TESTNET]: "bevm-testnet" /* BEVM_TESTNET */,
  [EndpointId.LISK_V2_TESTNET]: "lisk-testnet" /* LISK_TESTNET */,
  [EndpointId.PLUME2_V2_TESTNET]: "plume2-testnet" /* PLUME2_TESTNET */,
  [EndpointId.KEVNET_V2_TESTNET]: "kevnet-testnet" /* KEVNET_TESTNET */,
  [EndpointId.SOLANA_V2_TESTNET]: "solana-testnet" /* SOLANA_TESTNET */,
  [EndpointId.APTOS_V2_TESTNET]: "aptos-testnet" /* APTOS_TESTNET */,
  [EndpointId.INITIA_V2_TESTNET]: "initia-testnet" /* INITIA_TESTNET */,
  [EndpointId.MOVEMENT_V2_TESTNET]: "movement-testnet" /* MOVEMENT_TESTNET */,
  [EndpointId.BLE_V2_TESTNET]: "ble-testnet" /* BLE_TESTNET */,
  [EndpointId.BL2_V2_TESTNET]: "bl2-testnet" /* BL2_TESTNET */,
  [EndpointId.HYPERLIQUID_V2_TESTNET]: "hyperliquid-testnet" /* HYPERLIQUID_TESTNET */,
  [EndpointId.UNICHAIN_V2_TESTNET]: "unichain-testnet" /* UNICHAIN_TESTNET */,
  [EndpointId.MINATO_V2_TESTNET]: "minato-testnet" /* MINATO_TESTNET */,
  [EndpointId.WORLDCOIN_V2_TESTNET]: "worldcoin-testnet" /* WORLDCOIN_TESTNET */,
  [EndpointId.SUPERPOSITION_V2_TESTNET]: "superposition-testnet" /* SUPERPOSITION_TESTNET */,
  [EndpointId.HEMI_V2_TESTNET]: "hemi-testnet" /* HEMI_TESTNET */,
  [EndpointId.GAMESWIFT_V2_TESTNET]: "gameswift-testnet" /* GAMESWIFT_TESTNET */,
  [EndpointId.ODYSSEY_V2_TESTNET]: "odyssey-testnet" /* ODYSSEY_TESTNET */,
  [EndpointId.SOPHON_V2_TESTNET]: "sophon-testnet" /* SOPHON_TESTNET */,
  [EndpointId.MOKSHA_V2_TESTNET]: "moksha-testnet" /* MOKSHA_TESTNET */,
  [EndpointId.TON_V2_TESTNET]: "ton-testnet" /* TON_TESTNET */,
  [EndpointId.CITREA_V2_TESTNET]: "citrea-testnet" /* CITREA_TESTNET */,
  [EndpointId.BL3_V2_TESTNET]: "bl3-testnet" /* BL3_TESTNET */,
  [EndpointId.MP1_V2_TESTNET]: "mp1-testnet" /* MP1_TESTNET */,
  [EndpointId.SONIC_V2_TESTNET]: "sonic-testnet" /* SONIC_TESTNET */,
  [EndpointId.ROOTSTOCK_V2_TESTNET]: "rootstock-testnet" /* ROOTSTOCK_TESTNET */,
  [EndpointId.FLOW_V2_TESTNET]: "flow-testnet" /* FLOW_TESTNET */,
  [EndpointId.NIBIRU_V2_TESTNET]: "nibiru-testnet" /* NIBIRU_TESTNET */,
  [EndpointId.SWELL_V2_TESTNET]: "swell-testnet" /* SWELL_TESTNET */,
  [EndpointId.MEMECOREFORMICARIUM_V2_TESTNET]: "memecoreformicarium-testnet" /* MEMECOREFORMICARIUM_TESTNET */,
  [EndpointId.APEXFUSIONNEXUS_V2_TESTNET]: "apexfusionnexus-testnet" /* APEXFUSIONNEXUS_TESTNET */,
  [EndpointId.GOAT_V2_TESTNET]: "goat-testnet" /* GOAT_TESTNET */,
  [EndpointId.BL6_V2_TESTNET]: "bl6-testnet" /* BL6_TESTNET */,
  [EndpointId.INK_V2_TESTNET]: "ink-testnet" /* INK_TESTNET */,
  // sandbox
  [EndpointId.ETHEREUM_SANDBOX]: "ethereum-sandbox" /* ETHEREUM_SANDBOX */,
  [EndpointId.BSC_SANDBOX]: "bsc-sandbox" /* BSC_SANDBOX */,
  [EndpointId.AVALANCHE_SANDBOX]: "avalanche-sandbox" /* AVALANCHE_SANDBOX */,
  [EndpointId.POLYGON_SANDBOX]: "polygon-sandbox" /* POLYGON_SANDBOX */,
  [EndpointId.APTOS_SANDBOX]: "aptos-sandbox" /* APTOS_SANDBOX */,
  [EndpointId.OPTIMISM_SANDBOX]: "optimism-sandbox" /* OPTIMISM_SANDBOX */,
  [EndpointId.TRON_SANDBOX]: "tron-sandbox" /* TRON_SANDBOX */,
  [EndpointId.TRONDEV_SANDBOX]: "tron-sandbox" /* TRON_SANDBOX */,
  [EndpointId.ARBITRUM_SANDBOX]: "arbitrum-sandbox" /* ARBITRUM_SANDBOX */,
  [EndpointId.FANTOM_SANDBOX]: "fantom-sandbox" /* FANTOM_SANDBOX */,
  [EndpointId.METIS_SANDBOX]: "metis-sandbox" /* METIS_SANDBOX */,
  // v2 sandbox
  [EndpointId.ETHEREUM_V2_SANDBOX]: "ethereum-sandbox" /* ETHEREUM_SANDBOX */,
  [EndpointId.POLYGON_V2_SANDBOX]: "polygon-sandbox" /* POLYGON_SANDBOX */,
  [EndpointId.SOLANA_V2_SANDBOX]: "solana-sandbox" /* SOLANA_SANDBOX */,
  [EndpointId.BSC_V2_SANDBOX]: "bsc-sandbox" /* BSC_SANDBOX */,
  [EndpointId.AVALANCHE_V2_SANDBOX]: "avalanche-sandbox" /* AVALANCHE_SANDBOX */,
  [EndpointId.OPTIMISM_V2_SANDBOX]: "optimism-sandbox" /* OPTIMISM_SANDBOX */,
  [EndpointId.METIS_V2_SANDBOX]: "metis-sandbox" /* METIS_SANDBOX */,
  [EndpointId.APTOS_V2_SANDBOX]: "aptos-sandbox" /* APTOS_SANDBOX */,
  [EndpointId.INITIA_V2_SANDBOX]: "initia-sandbox" /* INITIA_SANDBOX */,
  [EndpointId.MOVEMENT_V2_SANDBOX]: "movement-sandbox" /* MOVEMENT_SANDBOX */,
  [EndpointId.TRON_V2_SANDBOX]: "tron-sandbox" /* TRON_SANDBOX */,
  [EndpointId.TRONDEV_V2_SANDBOX]: "tron-sandbox" /* TRON_SANDBOX */,
  [EndpointId.ARBITRUM_V2_SANDBOX]: "arbitrum-sandbox" /* ARBITRUM_SANDBOX */,
  [EndpointId.TON_V2_SANDBOX]: "ton-sandbox" /* TON_SANDBOX */
};

// src/constants/environment.ts
var ENVIRONMENT = {
  [EndpointId.ETHEREUM_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.BSC_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.AVALANCHE_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.POLYGON_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.ARBITRUM_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.OPTIMISM_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.FANTOM_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.SWIMMER_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.DFK_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.HARMONY_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.DEXALOT_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.CELO_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.MOONBEAM_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.INTAIN_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.FUSE_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.GNOSIS_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.APTOS_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.KLAYTN_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.METIS_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.COREDAO_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.METER_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.OKX_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.GOERLI_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.ZKSYNC_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.SHRAPNEL_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.DOS_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.ZKPOLYGON_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.SEPOLIA_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.MOONRIVER_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.NOVA_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.TENET_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.CANTO_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.KAVA_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.MANTLE_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.HUBBLE_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.ZKCONSENSYS_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.BASE_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.ZORA_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.TOMO_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.LOOT_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.TELOS_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.MERITCIRCLE_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.OPBNB_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.LIF3_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.ASTAR_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.AURORA_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.CONFLUX_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.ORDERLY_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.SCROLL_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.EON_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.XPLA_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.MANTA_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.PGN_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.SHIMMER_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.BB1_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.RARIBLE_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.XAI_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.REAL_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.TILTYARD_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.FRAXTAL_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.TRON_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.ZKATANA_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.MODE_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.BLAST_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.MASA_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.HOMEVERSE_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.MERLIN_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.DEGEN_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.SKALE_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.XLAYER_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.BOB_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.SANKO_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.SEI_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.KINTO_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.EBI_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.IOTA_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.CYBER_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.JOC_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.SOLANA_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.TAIKO_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.XCHAIN_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.ETHERLINK_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.BOUNCEBIT_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.GRAVITY_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.FLARE_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.ZKLINK_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.PEAQ_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.ZIRCUIT_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.LIGHTLINK_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.CODEX_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.LYRA_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.APE_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.REYA_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.BITLAYER_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.DM2VERSE_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.HEDERA_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.BEVM_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.PLUME_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.WORLDCHAIN_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.UNICHAIN_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.LISK_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.MORPH_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.ABSTRACT_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.SUPERPOSITION_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.EDU_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.HEMI_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.ISLANDER_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.MP1_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.SONIC_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.SWELL_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.SOPHON_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.ROOTSTOCK_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.FLOW_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.BL4_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.BL5_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.INK_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.SONEIUM_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.SPACE_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.GLUE_MAINNET]: "mainnet" /* MAINNET */,
  // v2 mainnet
  [EndpointId.ETHEREUM_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.BSC_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.AVALANCHE_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.POLYGON_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.ARBITRUM_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.OPTIMISM_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.FANTOM_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.SWIMMER_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.DFK_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.HARMONY_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.DEXALOT_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.CELO_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.MOONBEAM_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.INTAIN_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.FUSE_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.GNOSIS_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.KLAYTN_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.METIS_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.COREDAO_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.GOERLI_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.OKX_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.CANTO_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.ZKSYNC_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.SHRAPNEL_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.DOS_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.ZKPOLYGON_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.SEPOLIA_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.MOONRIVER_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.TENET_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.NOVA_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.METER_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.KAVA_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.MANTLE_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.HUBBLE_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.ZKCONSENSYS_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.BASE_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.ZORA_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.TOMO_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.LOOT_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.TELOS_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.MERITCIRCLE_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.OPBNB_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.LIF3_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.ASTAR_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.AURORA_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.CONFLUX_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.ORDERLY_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.SCROLL_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.EON_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.XPLA_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.MANTA_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.PGN_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.SHIMMER_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.BB1_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.RARIBLE_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.XAI_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.REAL_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.TILTYARD_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.FRAXTAL_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.MODE_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.TRON_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.ZKATANA_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.BLAST_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.MASA_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.HOMEVERSE_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.MERLIN_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.DEGEN_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.SKALE_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.XLAYER_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.BOB_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.SANKO_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.SEI_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.KINTO_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.EBI_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.IOTA_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.CYBER_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.JOC_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.SOLANA_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.TAIKO_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.XCHAIN_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.ETHERLINK_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.BOUNCEBIT_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.GRAVITY_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.FLARE_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.ZKLINK_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.PEAQ_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.ZIRCUIT_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.LIGHTLINK_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.APTOS_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.CODEX_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.LYRA_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.APE_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.REYA_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.BITLAYER_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.DM2VERSE_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.INITIA_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.MOVEMENT_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.HEDERA_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.BEVM_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.PLUME_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.WORLDCHAIN_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.UNICHAIN_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.LISK_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.MORPH_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.ABSTRACT_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.SUPERPOSITION_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.EDU_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.HEMI_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.ISLANDER_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.MP1_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.SONIC_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.SWELL_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.SOPHON_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.ROOTSTOCK_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.FLOW_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.BL4_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.BL5_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.INK_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.SONEIUM_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.SPACE_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.GLUE_V2_MAINNET]: "mainnet" /* MAINNET */,
  [EndpointId.TON_V2_MAINNET]: "mainnet" /* MAINNET */,
  // testnet
  [EndpointId.ETHEREUM_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BSC_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.POLYGON_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.FANTOM_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.HARMONY_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.AVALANCHE_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ARBITRUM_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.OPTIMISM_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.DFK_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.SWIMMER_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.DEXALOT_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.GNOSIS_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.CELO_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.APTOS_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.MOONBEAM_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.FUSE_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ZKSYNC_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.SHRAPNEL_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.DOS_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.KLAYTN_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.METIS_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.INTAIN_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.COREDAO_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ZKPOLYGON_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.OKX_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.SOLANA_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.METER_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ZKCONSENSYS_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.SEPOLIA_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BASE_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.AAVEGOTCHI_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.SCROLL_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.CATHAY_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.KAVA_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.TENET_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.CANTO_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ORDERLY_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BLOCKGEN_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.MERITCIRCLE_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.MANTLE_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.HUBBLE_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ZORA_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.TOMO_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.LOOT_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.TELOS_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.AURORA_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.OPBNB_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.SHIMMER_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.MONAD_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.LIF3_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.SPRUCE_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.PGJJTK_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ODA_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.KIWI_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ASTAR_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.CONFLUX_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.EON_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.XPLA_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.HOLESKY_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.INJECTIVE_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.IDEX_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ZKATANA_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.MANTA_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.FRAME_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.PGN_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.POLYGONCDK_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ARBSEP_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.OPTSEP_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BERA_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.VENN_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.RARIBLE_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.GUNZILLA_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.RC1_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ETHERLINK_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.KIWI2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.JOC_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BLAST_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.TRON_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BASESEP_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.MANTLESEP_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ZKPOLYGONSEP_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ZKSYNCSEP_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ZORASEP_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.XAI_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.TANGIBLE_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.EXOCORE_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.FRAXTAL_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.SEI_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.MODE_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.HEDERA_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.UNREAL_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.MASA_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.MERLIN_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.HOMEVERSE_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ZKASTAR_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.AMOY_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.DEGEN_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.XLAYER_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.FORM_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.LL1_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.MANTASEP_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.SKALE_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.TAIKO_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ZIRCUIT_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.CAMP_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.OLIVE_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.SANKO_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BOB_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.CYBER_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BOTANIX_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.XCHAIN_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ZKLINK_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.EBI_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.LINEASEP_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BESU1_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BOUNCEBIT_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.MORPH_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BARTIO_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.METISSEP_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.FLARE_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.GLUE_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.OPENCAMPUS_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.VANAR_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.PEAQ_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.FI_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.PLUME_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.CURTIS_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.IOTA_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.LYRA_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.LIGHTLINK_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BAHAMUT_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.CODEX_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.OTHERWORLD_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ABSTRACT_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ROOT_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.STORY_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.TREASURE_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.REYA_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BITLAYER_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.DM2VERSE_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.OZEAN_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BEVM_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.LISK_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.PLUME2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.KEVNET_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BLE_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BL2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.HYPERLIQUID_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.UNICHAIN_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.MINATO_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.WORLDCOIN_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.SUPERPOSITION_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.HEMI_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.GAMESWIFT_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ODYSSEY_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.SOPHON_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.MOKSHA_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.CITREA_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BL3_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.MP1_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.SONIC_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ROOTSTOCK_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.FLOW_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.NIBIRU_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.SWELL_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.MEMECOREFORMICARIUM_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.APEXFUSIONNEXUS_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.GOAT_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BL6_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.INK_TESTNET]: "testnet" /* TESTNET */,
  // v2 testnet
  [EndpointId.ETHEREUM_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.POLYGON_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ARBITRUM_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.OPTIMISM_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.AVALANCHE_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BSC_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.FANTOM_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.DFK_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.HARMONY_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.DEXALOT_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.CELO_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.MOONBEAM_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.FUSE_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.GNOSIS_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ZKSYNC_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.SHRAPNEL_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.DOS_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.KLAYTN_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.METIS_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.COREDAO_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.OKX_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.METER_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ZKCONSENSYS_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ZKPOLYGON_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.CANTO_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BASE_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.SEPOLIA_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.AAVEGOTCHI_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.SCROLL_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.CATHAY_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.KAVA_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.TENET_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ORDERLY_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BLOCKGEN_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.MERITCIRCLE_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.MANTLE_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.HUBBLE_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ZORA_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.TOMO_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.LOOT_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.TELOS_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.AURORA_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.OPBNB_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.SHIMMER_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.MONAD_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.LIF3_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.SPRUCE_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.PGJJTK_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ODA_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.KIWI_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ASTAR_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.CONFLUX_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.EON_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.XPLA_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.HOLESKY_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.INJECTIVE_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.IDEX_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ZKATANA_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.MANTA_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.FRAME_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.PGN_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.POLYGONCDK_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ARBSEP_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.OPTSEP_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BERA_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.VENN_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.RARIBLE_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.GUNZILLA_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.RC1_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ETHERLINK_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.KIWI2_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.JOC_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BLAST_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BASESEP_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.MANTLESEP_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ZKPOLYGONSEP_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ZKSYNCSEP_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ZORASEP_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.XAI_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.TANGIBLE_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.TRON_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.EXOCORE_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.FRAXTAL_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.SEI_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.MODE_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.HEDERA_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.UNREAL_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.MASA_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.MERLIN_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.HOMEVERSE_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ZKASTAR_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.AMOY_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.DEGEN_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.XLAYER_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.FORM_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.LL1_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.MANTASEP_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.SKALE_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.TAIKO_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ZIRCUIT_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.CAMP_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.OLIVE_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.SANKO_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BOB_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.CYBER_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BOTANIX_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.XCHAIN_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ZKLINK_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.EBI_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.LINEASEP_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BESU1_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BOUNCEBIT_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.MORPH_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BARTIO_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.METISSEP_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.FLARE_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.GLUE_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.OPENCAMPUS_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.VANAR_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.PEAQ_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.FI_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.PLUME_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.CURTIS_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.IOTA_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.LYRA_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.LIGHTLINK_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BAHAMUT_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.CODEX_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.OTHERWORLD_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ABSTRACT_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ROOT_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.STORY_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.TREASURE_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.REYA_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BITLAYER_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.DM2VERSE_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.OZEAN_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BEVM_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.LISK_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.PLUME2_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.KEVNET_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.SOLANA_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.APTOS_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.INITIA_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.MOVEMENT_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BLE_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BL2_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.HYPERLIQUID_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.UNICHAIN_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.MINATO_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.WORLDCOIN_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.SUPERPOSITION_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.HEMI_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.GAMESWIFT_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ODYSSEY_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.SOPHON_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.MOKSHA_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.TON_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.CITREA_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BL3_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.MP1_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.SONIC_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.ROOTSTOCK_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.FLOW_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.NIBIRU_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.SWELL_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.MEMECOREFORMICARIUM_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.APEXFUSIONNEXUS_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.GOAT_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.BL6_V2_TESTNET]: "testnet" /* TESTNET */,
  [EndpointId.INK_V2_TESTNET]: "testnet" /* TESTNET */,
  // sandbox
  [EndpointId.ETHEREUM_SANDBOX]: "testnet" /* TESTNET */,
  [EndpointId.BSC_SANDBOX]: "testnet" /* TESTNET */,
  [EndpointId.POLYGON_SANDBOX]: "testnet" /* TESTNET */,
  [EndpointId.AVALANCHE_SANDBOX]: "testnet" /* TESTNET */,
  [EndpointId.APTOS_SANDBOX]: "devnet" /* DEVNET */,
  [EndpointId.OPTIMISM_SANDBOX]: "testnet" /* TESTNET */,
  [EndpointId.TRON_SANDBOX]: "testnet" /* TESTNET */,
  [EndpointId.TRONDEV_SANDBOX]: "testnet" /* TESTNET */,
  [EndpointId.ARBITRUM_SANDBOX]: "testnet" /* TESTNET */,
  [EndpointId.FANTOM_SANDBOX]: "testnet" /* TESTNET */,
  [EndpointId.METIS_SANDBOX]: "testnet" /* TESTNET */,
  // v2 sandbox
  [EndpointId.ETHEREUM_V2_SANDBOX]: "devnet" /* DEVNET */,
  [EndpointId.POLYGON_V2_SANDBOX]: "devnet" /* DEVNET */,
  [EndpointId.SOLANA_V2_SANDBOX]: "devnet" /* DEVNET */,
  [EndpointId.BSC_V2_SANDBOX]: "devnet" /* DEVNET */,
  [EndpointId.AVALANCHE_V2_SANDBOX]: "devnet" /* DEVNET */,
  [EndpointId.OPTIMISM_V2_SANDBOX]: "testnet" /* TESTNET */,
  [EndpointId.METIS_V2_SANDBOX]: "devnet" /* DEVNET */,
  [EndpointId.APTOS_V2_SANDBOX]: "devnet" /* DEVNET */,
  [EndpointId.INITIA_V2_SANDBOX]: "devnet" /* DEVNET */,
  [EndpointId.MOVEMENT_V2_SANDBOX]: "devnet" /* DEVNET */,
  [EndpointId.TRON_V2_SANDBOX]: "devnet" /* DEVNET */,
  [EndpointId.TRONDEV_V2_SANDBOX]: "devnet" /* DEVNET */,
  [EndpointId.ARBITRUM_V2_SANDBOX]: "devnet" /* DEVNET */,
  [EndpointId.TON_V2_SANDBOX]: "devnet" /* DEVNET */
};

// src/constants/ulnv1.ts
var ULN_V1_CHAINS = [
  EndpointId.ETHEREUM_MAINNET,
  EndpointId.ETHEREUM_TESTNET,
  EndpointId.ETHEREUM_SANDBOX,
  EndpointId.BSC_MAINNET,
  EndpointId.BSC_TESTNET,
  EndpointId.BSC_SANDBOX,
  EndpointId.AVALANCHE_MAINNET,
  EndpointId.AVALANCHE_TESTNET,
  EndpointId.AVALANCHE_SANDBOX,
  EndpointId.POLYGON_MAINNET,
  EndpointId.POLYGON_TESTNET,
  EndpointId.POLYGON_SANDBOX,
  EndpointId.ARBITRUM_MAINNET,
  EndpointId.OPTIMISM_MAINNET,
  EndpointId.FANTOM_MAINNET,
  EndpointId.FANTOM_TESTNET,
  EndpointId.SWIMMER_MAINNET,
  EndpointId.SWIMMER_TESTNET,
  EndpointId.DFK_MAINNET,
  EndpointId.DFK_TESTNET,
  EndpointId.HARMONY_MAINNET,
  EndpointId.HARMONY_TESTNET,
  EndpointId.MOONBEAM_MAINNET,
  EndpointId.MOONBEAM_TESTNET,
  EndpointId.DEXALOT_TESTNET,
  EndpointId.CELO_TESTNET,
  EndpointId.INTAIN_TESTNET
];

// src/constants/uln.ts
var UlnVersion = /* @__PURE__ */ ((UlnVersion2) => {
  UlnVersion2[UlnVersion2["V1"] = 1] = "V1";
  UlnVersion2[UlnVersion2["V2"] = 2] = "V2";
  UlnVersion2[UlnVersion2["V3"] = 3] = "V3";
  return UlnVersion2;
})(UlnVersion || {});
function networkToEndpointId(network, version) {
  const name = network.replace("-local", "");
  const [chain, stage] = name.split("-");
  const key = version === "v1" /* V1 */ ? `${chain.toUpperCase()}_${stage.toUpperCase()}` : `${chain.toUpperCase()}_V2_${stage.toUpperCase()}`;
  invariant(key in EndpointId, `Invalid network name: ${network}, key: ${key}`);
  return EndpointId[key];
}
function networkToEnv(network, version) {
  if (network.includes("local") || network === "hardhat") {
    return "local" /* LOCAL */;
  }
  const endpointId = networkToEndpointId(network, version);
  return ENVIRONMENT[endpointId];
}
function networkToStage(network) {
  const name = network.replace("-local", "");
  const sp = name.split("-");
  if (sp.length <= 1) {
    throw new Error(`Invalid network name: ${network}`);
  }
  const stage = sp[1].toUpperCase();
  return Stage[stage];
}
function endpointIdToNetwork(endpointId, envOrIsLocal) {
  const key = EndpointId[endpointId];
  invariant(key, `Invalid endpointId: ${endpointId}`);
  const network = key.toLowerCase().replace(/_/g, "-").replace("-v2", "");
  if (envOrIsLocal === "local" /* LOCAL */ || envOrIsLocal === true) {
    return `${network}-local`;
  }
  return network;
}
function endpointIdToVersion(endpointId) {
  const key = EndpointId[endpointId];
  invariant(key, `Invalid endpointId: ${endpointId}`);
  return key.includes("V2") ? "v2" /* V2 */ : "v1" /* V1 */;
}
function endpointIdToChainKey(endpointId) {
  const chainKey = CHAIN_KEY[endpointId];
  invariant(chainKey, `No ChainKey for EndpointId: ${endpointId}`);
  return chainKey;
}
function chainAndStageToEndpointId(chain, stage, version) {
  const key = version === "v2" /* V2 */ ? `${chain.toUpperCase()}_V2_${stage.toUpperCase()}` : `${chain.toUpperCase()}_${stage.toUpperCase()}`;
  invariant(key in EndpointId, `Invalid key: ${key}`);
  return EndpointId[key];
}
function chainAndStageToNetwork(chain, stage, envOrIsLocal) {
  if (envOrIsLocal === "local" /* LOCAL */ || envOrIsLocal === true) {
    return `${chain}-${stage}-local`;
  }
  return `${chain}-${stage}`;
}
function endpointSpecToNetwork(spec) {
  return chainAndStageToNetwork(spec.chain, spec.stage, spec.env);
}
function endpointSpecToEnv(spec) {
  return spec.env;
}
function endpointSpecToEndpointId(spec) {
  return chainAndStageToEndpointId(spec.chain, spec.stage, spec.version);
}
function endpointIdToEndpointSpec(endpointId, env) {
  const chain = endpointIdToChain(endpointId);
  const stage = endpointIdToStage(endpointId);
  const version = endpointIdToVersion(endpointId);
  return { chain, stage, version, env };
}
function networkToChain(network) {
  return network.split("-")[0];
}
function networkToChainType(network) {
  const chain = networkToChain(network);
  return chainToChainType(chain);
}
function chainToChainType(chain) {
  switch (chain) {
    case Chain.APTOS:
    case Chain.MOVEMENT:
      return "aptos" /* APTOS */;
    case Chain.SOLANA:
      return "solana" /* SOLANA */;
    case Chain.INITIA:
      return "initia" /* INITIA */;
    case Chain.TON:
      return "ton" /* TON */;
    default:
      if (Object.values(EvmChain).includes(chain)) {
        return "evm" /* EVM */;
      } else {
        return "unknown" /* UNKNOWN */;
      }
  }
}
function getChainType(chain) {
  return chainToChainType(chain);
}
function endpointIdToChain(endpointId) {
  const key = EndpointId[endpointId];
  invariant(key, `Invalid endpointId: ${endpointId}`);
  return key.split("_")[0].toLowerCase();
}
function endpointIdToStage(endpointId) {
  if (endpointId < 1e4) {
    return "mainnet" /* MAINNET */;
  } else if (endpointId < 2e4) {
    return "testnet" /* TESTNET */;
  } else if (endpointId < 3e4) {
    return "sandbox" /* SANDBOX */;
  } else if (endpointId < 4e4) {
    return "mainnet" /* MAINNET */;
  } else if (endpointId < 5e4) {
    return "testnet" /* TESTNET */;
  } else if (endpointId < 6e4) {
    return "sandbox" /* SANDBOX */;
  }
  throw new Error(`Invalid endpointId: ${endpointId}`);
}
function endpointIdToChainType(endpointId) {
  const chain = endpointIdToChain(endpointId);
  return chainToChainType(chain);
}
function getNetworksForStage(stage) {
  const networks = [];
  for (const key in EndpointId) {
    if (Number(key) >= 0) {
      const network = endpointIdToNetwork(Number(key));
      const s = network.split("-")[1];
      if (stage === s) {
        networks.push(network);
      }
    }
  }
  return networks;
}
var ULN_V1_BIAS = 100;
var getEndpointVersionForUlnVersion = (ulnVersion) => {
  const [
    ,
    ,
    /*majorVerion*/
    /*minorVersion*/
    endpointVersion
  ] = ulnVersion.split(".");
  if (typeof endpointVersion === "undefined") {
    return "v1" /* V1 */;
  }
  const version = {
    "1": "v1" /* V1 */,
    "2": "v2" /* V2 */
  }[endpointVersion];
  if (version == null) {
    throw new Error(`Invalid ulnVersion: ${ulnVersion}`);
  }
  return version;
};
function getChainIdForNetwork(chain, stage, ulnVersion) {
  const endpointId = chainAndStageToEndpointId(
    chain,
    stage,
    getEndpointVersionForUlnVersion(ulnVersion)
  );
  return (ulnVersion == "1" ? endpointId - ULN_V1_BIAS : endpointId).toString();
}
function getNetworkForChainId(targetChainId) {
  if (ULN_V1_CHAINS.includes(targetChainId + ULN_V1_BIAS)) {
    const endpointId = targetChainId + ULN_V1_BIAS;
    const chain2 = endpointIdToChain(endpointId);
    const stage2 = networkToStage(endpointIdToNetwork(endpointId));
    return {
      chainName: chain2,
      env: stage2,
      ulnVersion: "1"
    };
  }
  const chain = endpointIdToChain(targetChainId);
  const stage = networkToStage(endpointIdToNetwork(targetChainId));
  return {
    chainName: chain,
    env: stage,
    ulnVersion: "2"
  };
}
function isNetworkEndpointIdSupported(network, endpointVersion) {
  try {
    networkToEndpointId(network, endpointVersion);
    return true;
  } catch (e) {
    return false;
  }
}
function isZKSyncBasedChain(chain) {
  return chain === Chain.ZKSYNC || chain === Chain.ZKSYNCSEP || chain === Chain.ZKLINK || chain === Chain.ABSTRACT || chain === Chain.SOPHON || chain === Chain.TREASURE;
}
function isTronChain(chain) {
  return chain === Chain.TRON || chain === Chain.TRONDEV;
}
function isEvmChain(chain) {
  return chainToChainType(chain) === "evm" /* EVM */;
}
function isAptosChain(chain) {
  return chainToChainType(chain) === "aptos" /* APTOS */;
}
function isSolanaChain(chain) {
  return chainToChainType(chain) === "solana" /* SOLANA */;
}
function isInitiaChain(chain) {
  return chainToChainType(chain) === "initia" /* INITIA */;
}
function isChain(value) {
  return Object.values(Chain).includes(value);
}

// src/chainspec.ts
var chainSpecConfig = {
  ["evm" /* EVM */]: {
    default: {
      addressSizeInBytes: 20,
      decimals: 18
    },
    [Chain.TRON]: {
      decimals: 6
    }
  },
  ["aptos" /* APTOS */]: {
    default: {
      addressSizeInBytes: 32,
      decimals: 8
    }
  },
  ["solana" /* SOLANA */]: {
    default: {
      addressSizeInBytes: 32,
      decimals: 9
    }
  }
};
var ChainSpecs = class {
  /**
   * Gets the address size in bytes for a given chain.
   *
   * @param {Chain} chain - The chain.
   * @returns {number} The address size in bytes.
   */
  static getAddressSizeInBytes(chain) {
    return this.getChainSpec(getChainType(chain), chain).addressSizeInBytes;
  }
  /**
   * Gets the chain specification for a given chain type and chain.
   *
   * @param {ChainType} chainType - The type of the chain.
   * @param {Chain | 'default'} chain - The chain or 'default'.
   * @returns {ChainSpec} The chain specification.
   * @throws {Error} If the configuration for the chain type is not found.
   */
  static getChainSpec(chainType, chain) {
    if (chainSpecConfig[chainType] === void 0) {
      throw new Error(`config for ${chainType} not found in staticConfig`);
    }
    const config = {
      ...chainSpecConfig[chainType]?.default,
      ...chainSpecConfig[chainType]?.[chain]
    };
    return config;
  }
};

export { AptosChain, CHAIN_KEY, Chain, ChainKey, ChainSpecs, ChainType, ChannelId, ENVIRONMENT, EndpointId, EndpointV2IdBase, EndpointVersion, Environment, EvmChain, InitiaChain, MainnetEndpointId, MainnetV2EndpointId, MessageLibCmdRead, MessageLibVersionV1, MessageLibVersionV2, SandboxEndpointId, SandboxV2EndpointId, SolanaChain, Stage, TestnetEndpointId, TestnetV2EndpointId, TonChain, ULN_V1_CHAINS, UlnVersion, chainAndStageToEndpointId, chainAndStageToNetwork, chainToChainType, endpointIdToChain, endpointIdToChainKey, endpointIdToChainType, endpointIdToEndpointSpec, endpointIdToNetwork, endpointIdToStage, endpointIdToVersion, endpointSpecToEndpointId, endpointSpecToEnv, endpointSpecToNetwork, getChainIdForNetwork, getChainType, getEndpointVersionForUlnVersion, getNetworkForChainId, getNetworksForStage, isAptosChain, isChain, isEvmChain, isInitiaChain, isNetworkEndpointIdSupported, isSolanaChain, isTronChain, isZKSyncBasedChain, networkToChain, networkToChainType, networkToEndpointId, networkToEnv, networkToStage };
//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map